import type { Translations } from "./en";

const ar: Translations = {
  dir: "rtl" as Translations["dir"],
  nav: {
    shopAll: "تسوق الكل",
    contactUs: "اتصل بنا",
    myAccount: "حسابي",
    myWishlist: "قائمة الرغبات",
    myOrders: "طلباتي",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    createAccount: "إنشاء حساب",
    cart: "السلة",
    wishlist: "المفضلة",
    search: "ابحث عن منتجات...",
  },
  footer: {
    tagline: "المنصة المتكاملة لأعمالك التجارية عبر الإنترنت. إدارة المنتجات والطلبات والعملاء بسهولة.",
    shop: "التسوق",
    allProducts: "جميع المنتجات",
    featured: "المميزة",
    onSale: "التخفيضات",
    support: "الدعم",
    faq: "الأسئلة الشائعة",
    shippingReturns: "الشحن والإرجاع",
    contactUs: "اتصل بنا",
    admin: "لوحة التحكم",
    dashboard: "الرئيسية",
    manageProducts: "إدارة المنتجات",
    manageOrders: "إدارة الطلبات",
    rights: "جميع الحقوق محفوظة.",
    terms: "الشروط",
    privacy: "الخصوصية",
    aboutUs: "من نحن",
    pageNotFound: "الصفحة غير موجودة",
    backToHome: "العودة للرئيسية",
  },
  contact: {
    title: "اتصل بنا",
    subtitle: "يسعدنا سماع رأيك. أرسل لنا رسالة وسنرد عليك في أقرب وقت ممكن.",
    formTitle: "أرسل لنا رسالة",
    name: "الاسم الكامل",
    namePlaceholder: "اسمك",
    email: "البريد الإلكتروني",
    emailPlaceholder: "your@email.com",
    phone: "رقم الهاتف (واتساب)",
    phonePlaceholder: "+966 5XXXXXXXX",
    subject: "الموضوع",
    subjectPlaceholder: "كيف يمكننا مساعدتك؟",
    message: "الرسالة",
    messagePlaceholder: "أخبرنا المزيد عن استفسارك...",
    send: "إرسال الرسالة",
    sending: "جاري الإرسال...",
    successTitle: "تم إرسال الرسالة!",
    successMessage: "شكراً لتواصلك معنا. سنرد عليك خلال 24 ساعة.",
    sendAnother: "إرسال رسالة أخرى",
    infoTitle: "تواصل معنا",
    emailLabel: "البريد الإلكتروني",
    phoneLabel: "الهاتف",
    addressLabel: "العنوان",
    hoursLabel: "ساعات العمل",
    emailValue: "",
    phoneValue: "+966 50 000 0000",
    addressValue: "الرياض، المملكة العربية السعودية",
    hoursValue: "الأحد - الخميس: 9:00 ص - 6:00 م",
  },
  home: {
    heroTitle: "اكتشف منتجات مذهلة",
    heroSubtitle: "تسوق أحدث الصيحات بأسعار لا تقبل المنافسة وتوصيل سريع",
    shopNow: "تسوق الآن",
    featuredCategories: "الفئات المميزة",
    viewAll: "عرض الكل",
    featuredProducts: "المنتجات المميزة",
    trendingProducts: "المنتجات الرائجة",
    addToCart: "أضف إلى السلة",
    sale: "تخفيض",
  },
  product: {
    addToCart: "أضف إلى السلة",
    addedToCart: "تمت الإضافة للسلة",
    addedToCartDesc: "{qty}x {name} تمت إضافته إلى سلة التسوق.",
    viewCart: "عرض السلة",
    adding: "جاري الإضافة...",
    addToWishlist: "أضف إلى المفضلة",
    removeFromWishlist: "إزالة من المفضلة",
    addedToWishlist: "تمت الإضافة للمفضلة",
    removedFromWishlist: "تمت الإزالة من المفضلة",
    reviews: "التقييمات",
    noReviews: "لا توجد تقييمات بعد. كن أول من يقيّم هذا المنتج!",
    writeReview: "اكتب تقييماً",
    yourName: "اسمك",
    rating: "التقييم",
    review: "المراجعة",
    submitReview: "إرسال التقييم",
    reviewSubmitted: "تم إرسال التقييم بنجاح!",
    reviewFailed: "فشل إرسال التقييم.",
    relatedProducts: "منتجات ذات صلة",
    description: "الوصف",
    inStock: "متوفر",
    outOfStock: "غير متوفر",
    available: "متوفر",
    quantity: "الكمية",
    sku: "رمز المنتج",
    category: "الفئة",
    brand: "الماركة",
    compare: "قارن",
    productNotFound: "المنتج غير موجود",
    productNotFoundDesc: "المنتج الذي تبحث عنه غير موجود أو تمت إزالته.",
    backToShop: "العودة للمتجر",
    home: "الرئيسية",
    shop: "المتجر",
    securePayment: "معالجة دفع آمنة",
    returnPolicy: "سياسة إرجاع لمدة 30 يوم",
    sale: "تخفيض",
    noImage: "لا توجد صورة",
    viewProduct: "عرض المنتج",
  },
  shop: {
    title: "المتجر",
    allCategories: "جميع الفئات",
    sortBy: "ترتيب حسب",
    newest: "الأحدث",
    priceLowHigh: "السعر: من الأقل إلى الأعلى",
    priceHighLow: "السعر: من الأعلى إلى الأقل",
    nameAZ: "الاسم: أ - ي",
    nameZA: "الاسم: ي - أ",
    noProducts: "لا توجد منتجات",
    noProductsHint: "حاول تعديل الفلاتر أو كلمة البحث.",
    filters: "الفلاتر",
    filtersDesc: "تحسين نتائج البحث",
    clearFilters: "مسح جميع الفلاتر",
    productsFound: "منتج",
    loadingProducts: "جاري تحميل المنتجات...",
    allProducts: "جميع المنتجات",
    allBrands: "جميع العلامات",
    categories: "الفئات",
    brands: "الماركات",
    filterBy: "تصفية حسب",
    featuredProducts: "المنتجات المميزة",
    newestArrivals: "أحدث المنتجات",
    noImage: "لا توجد صورة",
    sale: "تخفيض",
    outOfStock: "نفذ المخزون",
    addedToCompare: "تمت الإضافة للمقارنة",
    removedFromCompare: "تمت الإزالة من المقارنة",
    addToCompare: "إضافة للمقارنة",
    removeFromCompare: "إزالة من المقارنة",
    maxCompare: "الحد الأقصى {n} منتجات للمقارنة",
  },
  cart: {
    title: "سلة التسوق",
    empty: "سلة التسوق فارغة",
    emptyDesc: "يبدو أنك لم تضف أي منتجات إلى سلة التسوق بعد.",
    continueShopping: "متابعة التسوق",
    startShopping: "ابدأ التسوق",
    subtotal: "المجموع الفرعي",
    shipping: "الشحن",
    total: "الإجمالي",
    checkout: "إتمام الشراء",
    remove: "إزالة",
    quantity: "الكمية",
    product: "المنتج",
    price: "السعر",
    qty: "الكمية",
    loadingCart: "جاري تحميل السلة...",
    itemRemoved: "تمت إزالة المنتج من السلة.",
    orderSummary: "ملخص الطلب",
    shippingTax: "الشحن والضريبة",
    calculatedAtCheckout: "يُحسب عند الدفع",
    discount: "الخصم",
    couponCode: "كود الخصم",
    apply: "تطبيق",
    couponFailed: "فشل التحقق من الكوبون.",
    noImg: "لا صورة",
  },
  checkout: {
    title: "إتمام الشراء",
    contactInfo: "معلومات الاتصال",
    fullName: "الاسم الكامل",
    emailAddress: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    savedAddresses: "العناوين المحفوظة",
    newAddress: "إدخال عنوان جديد",
    shippingAddress: "عنوان الشحن",
    address: "العنوان",
    city: "المدينة",
    country: "الدولة",
    zipCode: "الرمز البريدي",
    billingAddress: "عنوان الفاتورة",
    sameAsShipping: "نفس عنوان الشحن",
    paymentMethod: "طريقة الدفع",
    creditCard: "بطاقة ائتمان",
    paypal: "باي بال",
    placeOrder: "تأكيد الطلب",
    processing: "جاري المعالجة...",
    orderSummary: "ملخص الطلب",
    subtotal: "المجموع الفرعي",
    shipping: "الشحن",
    total: "الإجمالي",
  },
  account: {
    title: "حسابي",
    welcome: "مرحباً",
    orders: "الطلبات",
    profile: "الملف الشخصي",
    addresses: "العناوين",
    password: "كلمة المرور",
    orderHistory: "سجل الطلبات",
    orderHistoryDesc: "عرض طلباتك السابقة والحالية",
    noOrders: "لم تقم بأي طلبات بعد.",
    startShopping: "ابدأ التسوق",
    personalInfo: "المعلومات الشخصية",
    personalInfoDesc: "تحديث الاسم والبريد والهاتف",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    emailNotChange: "لا يمكن تغيير البريد الإلكتروني",
    phone: "الهاتف",
    saveChanges: "حفظ التغييرات",
    saving: "جاري الحفظ...",
    addressBook: "دفتر العناوين",
    addressBookDesc: "إدارة عناوين الشحن والفوترة",
    addAddress: "إضافة عنوان",
    addFirstAddress: "أضف عنوانك الأول",
    noAddresses: "لم تضف أي عناوين بعد.",
    editAddress: "تعديل العنوان",
    addNewAddress: "إضافة عنوان جديد",
    label: "التصنيف",
    labelPlaceholder: "مثال: المنزل، العمل، المكتب",
    fullName: "الاسم الكامل",
    addressField: "العنوان",
    addressPlaceholder: "الشارع، الشقة، الجناح",
    setDefault: "تعيين كعنوان افتراضي",
    updateAddress: "تحديث العنوان",
    default: "افتراضي",
    edit: "تعديل",
    delete: "حذف",
    setAsDefault: "تعيين كافتراضي",
    changePassword: "تغيير كلمة المرور",
    changePasswordDesc: "تحديث كلمة مرور الحساب",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    updatePassword: "تحديث كلمة المرور",
    updating: "جاري التحديث...",
    returnBtn: "إرجاع",
    view: "عرض",
    requestReturn: "طلب إرجاع",
    selectItems: "اختر المنتجات للإرجاع",
    returnReason: "سبب الإرجاع *",
    returnReasonPlaceholder: "يرجى وصف السبب...",
    returnNotes: "ملاحظات إضافية (اختياري)",
    returnNotesPlaceholder: "أي تفاصيل إضافية...",
    cancel: "إلغاء",
    submitReturn: "تقديم طلب الإرجاع",
    submitting: "جاري التقديم...",
  },
  auth: {
    signIn: "تسجيل الدخول",
    signInDesc: "أدخل بيانات الاعتماد للوصول إلى حسابك",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    signInBtn: "تسجيل الدخول",
    signingIn: "جاري تسجيل الدخول...",
    noAccount: "ليس لديك حساب؟",
    createAccount: "إنشاء حساب",
    createAccountDesc: "أدخل بياناتك لإنشاء حساب جديد",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    phone: "الهاتف",
    confirmPassword: "تأكيد كلمة المرور",
    register: "إنشاء حساب",
    registering: "جاري الإنشاء...",
    haveAccount: "لديك حساب بالفعل؟",
  },
  wishlist: {
    title: "المفضلة",
    myWishlist: "قائمة رغباتي",
    items: "منتج",
    empty: "قائمة رغباتك فارغة",
    emptyDesc: "تصفح المنتجات وأضف مفضلاتك!",
    signInRequired: "يرجى تسجيل الدخول لعرض قائمة الرغبات.",
    loading: "جاري تحميل قائمة الرغبات...",
    removed: "تمت الإزالة من المفضلة.",
    startShopping: "ابدأ التسوق",
    viewProduct: "عرض المنتج",
    noImage: "لا توجد صورة",
    sale: "تخفيض",
    outOfStock: "غير متوفر",
  },
  compare: {
    title: "مقارنة المنتجات",
    products: "منتجات",
    emptyDesc: "لم يتم اختيار أي منتجات للمقارنة. تصفح المتجر واضغط على زر المقارنة على المنتجات التي تريد مقارنتها.",
    browseProducts: "تصفح المنتجات",
    clearAll: "مسح الكل",
    feature: "الميزة",
    price: "السعر",
    rating: "التقييم",
    category: "الفئة",
    brand: "الماركة",
    sku: "رمز المنتج",
    availability: "التوفر",
    weight: "الوزن",
    description: "الوصف",
    action: "الإجراء",
    viewProduct: "عرض المنتج",
    inStock: "متوفر",
    outOfStock: "غير متوفر",
    noImage: "لا توجد صورة",
    loading: "جاري تحميل المقارنة...",
    selectedForComparison: "محدد للمقارنة",
    clear: "مسح",
    compareNow: "قارن الآن",
    productSelected: "منتج",
    productsSelected: "منتجات",
    kg: "كجم",
  },
  orderConfirmation: {
    thankYou: "شكراً لطلبك!",
    receivedOrder: "لقد استلمنا طلبك وسنتواصل معك فور شحن الطرد.",
    orderNumber: "رقم الطلب",
    orderDetails: "تفاصيل الطلب",
    subtotal: "المجموع الفرعي",
    discount: "الخصم",
    shipping: "الشحن",
    tax: "الضريبة",
    total: "الإجمالي",
    shippingAddress: "عنوان الشحن",
    paymentMethod: "طريقة الدفع",
    paymentStatus: "الحالة",
    printInvoice: "طباعة الفاتورة",
    continueShopping: "متابعة التسوق",
    orderNotFound: "الطلب غير موجود",
    returnToHome: "العودة للرئيسية",
    loadingOrder: "جاري تحميل تفاصيل الطلب...",
  },
  common: {
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "تم بنجاح",
    backToHome: "العودة للرئيسية",
    viewOrder: "عرض الطلب",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    delete: "حذف",
    edit: "تعديل",
    actions: "الإجراءات",
    active: "نشط",
    inactive: "غير نشط",
    disabled: "معطل",
    email: "البريد الإلكتروني",
    status: "الحالة",
    noData: "لا توجد بيانات",
    confirmDelete: "هل أنت متأكد من الحذف؟",
    yes: "نعم",
    no: "لا",
    search: "بحث",
    all: "الكل",
    previous: "السابق",
    next: "التالي",
  },
  admin: {
    title: "لوحة التحكم",
    signedInAs: "مسجل الدخول كـ",
    backToStore: "العودة للمتجر",
    signOut: "تسجيل الخروج",
    sidebar: {
      dashboard: "لوحة التحكم",
      products: "المنتجات",
      categories: "الأقسام",
      orders: "الطلبات",
      customers: "العملاء",
      coupons: "الكوبونات",
      banners: "البانرات",
      returns: "المرتجعات",
      brands: "الماركات",
      settings: "الإعدادات",
    },
    login: {
      title: "تسجيل دخول المشرف",
      subtitle: "سجل الدخول للوصول إلى لوحة التحكم",
      username: "اسم المستخدم",
      identifier: "اسم المستخدم أو البريد الإلكتروني أو رقم الجوال",
      identifierPlaceholder: "admin / you@example.com / 05xxxxxxxx",
      identifierHint: "تقدر تسجّل الدخول باسم المستخدم، البريد الإلكتروني، أو رقم الجوال/واتساب.",
      password: "كلمة المرور",
      signIn: "تسجيل الدخول",
      signingIn: "جاري تسجيل الدخول...",
      welcome: "مرحباً!",
      welcomeDesc: "تم تسجيل الدخول كمشرف.",
      loginFailed: "فشل تسجيل الدخول",
      tabUsername: "اسم المستخدم",
      tabEmail: "البريد",
      tabWhatsapp: "واتساب",
      emailLabel: "البريد الإلكتروني",
      emailHint: "راح نرسل لك رمز تحقق مكوّن من 4 أرقام إلى بريدك.",
      whatsappLabel: "رقم الواتساب",
      whatsappHint: "راح نرسل لك رمز تحقق مكوّن من 4 أرقام عبر الواتساب. مثال: ‎05xxxxxxxx أو ‎+9665xxxxxxxx",
      sendCode: "إرسال رمز التحقق",
      sendingCode: "جاري الإرسال...",
      otpSentEmail: "تم إرسال الرمز إلى بريدك",
      otpSentWhatsapp: "تم إرسال الرمز عبر الواتساب",
      otpSentDesc: "افتح الرسالة وانسخ الأرقام الأربعة.",
      codeSentTo: "أرسلنا الرمز إلى:",
      codeLabel: "رمز التحقق (4 أرقام)",
      verifyAndSignIn: "تحقّق ودخول",
      verifying: "جاري التحقق...",
      resendCode: "إعادة الإرسال",
      resendIn: "إعادة الإرسال خلال",
      changeIdentifier: "تغيير العنوان",
      forgotPassword: "نسيت كلمة المرور؟",
    },
    dashboard: {
      title: "لوحة التحكم",
      welcomeMsg: "مرحباً بعودتك. إليك ما يحدث في متجرك اليوم.",
      totalRevenue: "إجمالي الإيرادات",
      orders: "الطلبات",
      customers: "العملاء",
      products: "المنتجات",
      today: "اليوم",
      pending: "قيد الانتظار",
      lowStock: "مخزون منخفض",
      revenueOverview: "نظرة عامة على الإيرادات",
      pastWeek: "الأسبوع الحالي",
      pastMonth: "الشهر الحالي",
      pastQuarter: "آخر 3 أشهر",
      pastYear: "السنة الحالية",
      orderStatus: "حالة الطلبات",
      orderStatusDesc: "الحالة الحالية لجميع الطلبات",
      recentOrders: "الطلبات الأخيرة",
      viewAll: "عرض الكل",
      noRecentOrders: "لا توجد طلبات حديثة.",
      topProducts: "أفضل المنتجات",
      sold: "مبيع",
      noSalesData: "لا توجد بيانات مبيعات بعد.",
      onlineNow: "المتواجدون الان",
      totalSales: "اجمالي المبيعات",
      totalOrders: "اجمالي الطلبات",
      totalAbandonedCarts: "سلات التسوق المهجورة",
      more: "المزيد..",
      viewMore: "المزيد..",
      periodToday: "اليوم",
      periodWeek: "هذا الأسبوع",
      periodMonth: "هذا الشهر",
      periodYear: "هذه السنة",
      latestOrders: "آخر الطلبات",
      latestActivity: "آخر الأحداث",
      orderNumber: "رقم الطلب",
      customerName: "اسم العميل",
      status: "الحالة",
      orderDate: "تاريخ الطلب",
      total: "الاجمالي",
      edit: "تحرير",
      noActivity: "لا توجد أحداث حديثة.",
    },
    products: {
      title: "المنتجات",
      addProduct: "إضافة منتج",
      exportCsv: "تصدير CSV",
      importCsv: "استيراد CSV",
      searchProducts: "البحث في المنتجات...",
      image: "الصورة",
      name: "الاسم",
      sku: "رمز المنتج",
      price: "السعر",
      stock: "المخزون",
      status: "الحالة",
      actions: "الإجراءات",
      edit: "تعديل",
      delete: "حذف",
      openMenu: "فتح القائمة",
      loadingProducts: "جاري تحميل المنتجات...",
      noProducts: "لا توجد منتجات.",
      deleteConfirm: "هل أنت متأكد من حذف هذا المنتج؟",
      deleted: "تم حذف المنتج بنجاح.",
      deleteFailed: "فشل حذف المنتج.",
      exported: "تم تصدير المنتجات بنجاح.",
      exportFailed: "فشل تصدير المنتجات.",
      importTitle: "استيراد المنتجات من CSV",
      importDesc: "ارفع ملف CSV لاستيراد المنتجات. استخدم نفس تنسيق التصدير. المنتجات ذات المعرفات الموجودة سيتم تحديثها. الصفوف الجديدة ستُنشأ.",
      importing: "جاري استيراد المنتجات...",
      imported: "مستورد",
      updated: "محدّث",
      failed: "فشل",
      importFailed: "فشل استيراد المنتجات.",
      noImg: "لا صورة",
    },
    productEdit: {
      createTitle: "إنشاء منتج",
      editTitle: "تعديل المنتج",
      nameEn: "الاسم (EN)",
      nameAr: "الاسم (AR)",
      nameArPlaceholder: "اسم المنتج بالعربية",
      skuLabel: "رمز المنتج",
      priceLabel: "السعر",
      salePrice: "سعر التخفيض (اختياري)",
      costPrice: "سعر التكلفة (اختياري)",
      quantityInStock: "الكمية في المخزون",
      category: "الفئة",
      selectCategory: "اختر فئة",
      brand: "الماركة",
      selectBrand: "اختر علامة تجارية",
      noBrand: "بدون علامة تجارية",
      statusLabel: "الحالة",
      selectStatus: "اختر الحالة",
      shortDescEn: "وصف مختصر (EN)",
      shortDescAr: "وصف مختصر (AR)",
      shortDescArPlaceholder: "الوصف المختصر بالعربية",
      fullDescEn: "الوصف الكامل (EN)",
      fullDescAr: "الوصف الكامل (AR)",
      fullDescArPlaceholder: "الوصف الكامل بالعربية",
      productImage: "صورة المنتج",
      featuredProduct: "منتج مميز",
      featuredDesc: "سيظهر هذا المنتج في الصفحة الرئيسية.",
      cancel: "إلغاء",
      saveProduct: "حفظ المنتج",
      created: "تم إنشاء المنتج بنجاح.",
      updated: "تم تحديث المنتج بنجاح.",
      createFailed: "فشل إنشاء المنتج.",
      updateFailed: "فشل تحديث المنتج.",
    },
    categories: {
      title: "الأقسام",
      categoryList: "قائمة الأقسام",
      addCategory: "إضافة قسم",
      editCategory: "تعديل القسم",
      newCategory: "قسم جديد",
      nameEn: "الاسم (EN)",
      nameAr: "الاسم (AR)",
      nameArPlaceholder: "اسم الفئة بالعربية",
      descEn: "الوصف (EN)",
      descAr: "الوصف (AR)",
      descArPlaceholder: "الوصف بالعربية",
      categoryImage: "صورة القسم",
      sortOrder: "ترتيب الفرز",
      image: "الصورة",
      name: "الاسم",
      categoryName: "اسم القسم",
      parentCategory: "القسم الأصلي",
      status: "الحالة",
      active: "نشط",
      inactive: "غير نشط",
      allStatuses: "الكل",
      noParent: "بدون (قسم رئيسي)",
      filter: "تصفية",
      productsCount: "المنتجات",
      actions: "الإجراءات",
      edit: "تحرير",
      categoryUpdated: "تم تحديث القسم",
      categoryCreated: "تم إنشاء القسم",
      saveFailed: "فشل حفظ القسم",
      categoryDeleted: "تم حذف القسم",
      selectAll: "تحديد الكل",
      deleteSelected: "حذف المحدد",
      selectedCount: "محدد",
      noCategories: "لا توجد أقسام",
      noCategoriesHint: "حاول تعديل الفلاتر أو أضف قسماً جديداً.",
      breadcrumbHome: "الرئيسية",
      breadcrumbCategories: "الأقسام",
    },
    orders: {
      title: "الطلبات",
      filterByStatus: "تصفية حسب الحالة",
      allOrders: "جميع الطلبات",
      pending: "قيد الانتظار",
      processing: "قيد المعالجة",
      shipped: "تم الشحن",
      delivered: "تم التوصيل",
      cancelled: "ملغي",
      refunded: "مسترد",
      orderNumber: "رقم الطلب",
      date: "التاريخ",
      customer: "العميل",
      status: "الحالة",
      payment: "الدفع",
      total: "الإجمالي",
      actions: "الإجراءات",
      loadingOrders: "جاري تحميل الطلبات...",
      noOrders: "لا توجد طلبات.",
      paymentPending: "قيد الانتظار",
      paymentPaid: "مدفوع",
      paymentFailed: "فشل",
      paymentRefunded: "مسترد",
      filter: "تصفية",
      filterOrders: "فرز الطلبات",
      orderStatus: "حالة الطلب",
      minTotal: "أدنى اجمالي",
      maxTotal: "أعلى اجمالي",
      dateAdded: "تاريخ الاضافة",
      dateModified: "تاريخ التعديل",
      customerName: "العميل",
      email: "البريد الالكتروني",
      paymentMethod: "الدفع",
      deliveryMethod: "التوصيل",
      region: "المنطقة",
      city: "المدينة",
      phone: "رقم الجوال",
      edit: "تحرير",
      updateSelected: "تحديث الطلبات المحددة",
    },
    orderDetail: {
      order: "طلب",
      printInvoice: "طباعة الفاتورة",
      items: "المنتجات",
      paymentSummary: "ملخص الدفع",
      subtotal: "المجموع الفرعي",
      shipping: "الشحن",
      tax: "الضريبة",
      discount: "الخصم",
      total: "الإجمالي",
      paymentStatus: "حالة الدفع",
      orderStatus: "حالة الطلب",
      customerTitle: "العميل",
      shippingAddress: "عنوان الشحن",
      orderNotFound: "الطلب غير موجود.",
      customerDetails: "تفاصيل العميل",
      orderDetails: "تفاصيل الطلب",
      orderDate: "تاريخ الطلب",
      paymentMethodLabel: "طريقة الدفع",
      shippingMethodLabel: "طريقة الشحن",
      sku: "SKU",
      productName: "الطلبات",
      quantity: "الكمية",
      unitPrice: "سعر الوحدة",
      subtotalBeforeTax: "الاجمالي قبل الضريبة",
      vat: "ضريبة القيمة المضافة",
      excise: "الضريبة الانتقائية",
      orderHistory: "سجل الطلبات",
      addToHistory: "إضافة إلى سجل الطلبات",
      historyDate: "تاريخ الاضافة",
      historyNotes: "ملاحظات",
      historyStatus: "الحالة",
      customerNotified: "نسبه العميل",
      notifyCustomer: "نسبه العميل",
      notes: "ملاحظات",
      addToRecord: "إضافة إلى السجل",
      yes: "نعم",
      no: "لا",
      sms: "SMS",
      history: "السجل",
      additional: "إضافي",
    },
    customers: {
      title: "العملاء",
      searchCustomers: "البحث في العملاء...",
      name: "الاسم",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      orders: "الطلبات",
      totalSpent: "إجمالي الإنفاق",
      lastOrder: "آخر طلب",
      group: "المجموعة",
      status: "الحالة",
      actions: "الإجراءات",
      noCustomers: "لا يوجد عملاء.",
      noGroup: "بدون مجموعة",
      allGroups: "جميع المجموعات",
      allStatuses: "الكل",
      noGroupAssigned: "غير مصنف",
      filter: "تصفية",
      customerList: "قائمة العملاء",
      never: "لم يطلب",
      customerName: "اسم العميل",
      customerGroup: "مجموعة العميل",
      approval: "الموافقة",
      registrationDate: "تاريخ التسجيل",
      customerIp: "أي بي العميل - IP",
      dateFrom: "من",
      dateTo: "إلى",
      ip: "أي بي",
      totalValue: "القيمة الإجمالية",
      edit: "تحرير",
      approved: "تمكين",
      notApproved: "غير معتمد",
      enabled: "تمكين",
      disabled: "معطل",
    },
    customerDetail: {
      editDetails: "تعديل البيانات",
      eraseData: "حذف بيانات العميل",
      eraseDataTitle: "تأكيد حذف بيانات العميل",
      eraseDataDescription: "بناءً على طلب العميل، سيتم استبدال الاسم والبريد الإلكتروني ورقم الجوال برموز تشير إلى أن البيانات قد حُذفت. سيتم حذف جميع العناوين المحفوظة نهائياً. تبقى الطلبات السابقة وبياناتها كما هي للأرشفة المالية. هذا الإجراء لا يمكن التراجع عنه.",
      eraseDataConfirm: "نعم، احذف البيانات",
      eraseDataCancel: "إلغاء",
      eraseDataSuccess: "تم حذف بيانات العميل وتحويل هويته إلى مجهولة.",
      eraseDataFailed: "فشل حذف بيانات العميل.",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      address: "العنوان",
      city: "المدينة",
      country: "الدولة",
      zipCode: "الرمز البريدي",
      status: "الحالة",
      customerGroup: "مجموعة العميل",
      noGroup: "بدون مجموعة",
      saveChanges: "حفظ التغييرات",
      customerUpdated: "تم تحديث بيانات العميل بنجاح.",
      updateFailed: "فشل تحديث بيانات العميل.",
      summary: "الملخص",
      totalOrders: "إجمالي الطلبات",
      totalSpent: "إجمالي الإنفاق",
      avgOrderValue: "متوسط قيمة الطلب",
      lastOrderDate: "آخر طلب",
      customerSince: "عميل منذ",
      customerNotFound: "العميل غير موجود.",
      customFields: "حقول مخصصة",
      noCustomFields: "لا توجد حقول مخصصة.",
      fieldsSaved: "تم حفظ الحقول المخصصة.",
      fieldsSaveFailed: "فشل حفظ الحقول المخصصة.",
      tabGeneral: "عام",
      tabOrderHistory: "سجل الطلبات",
      tabPurchasedProducts: "المنتجات المشتراه",
      tabShoppingCart: "سلة الشراء",
      tabWishlist: "المفضلة",
      tabCustomerTracking: "تتبع العميل",
      tabHistory: "السجل",
      tabCustomerBalance: "رصيد العميل",
      tabRewardPoints: "نقاط المكافآت",
      tabIpAddress: "عنوان الآي بي",
      password: "كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      gender: "الجنس",
      male: "ذكر",
      female: "انثى",
      newsletter: "القائمة البريدية",
      enabled: "تمكين",
      approval: "الموافقة",
      yes: "نعم",
      no: "لا",
      safe: "آمن",
      note: "ملاحظة",
      orderNumber: "رقم الطلب",
      dateAdded: "تاريخ الإضافة",
      invoiceNo: "رقم الفاتورة",
      shippingMethod: "طريقة الشحن",
      paymentMethod: "طريقة الدفع",
      orderStatus: "الحالة",
      store: "المتجر",
      currency: "العملة",
      products: "المنتجات",
      total: "المجموع",
      shipping: "الشحن",
      tax: "الضريبة",
      orderTotal: "إجمالي الطلب",
      totals: "المجاميع",
      allStatuses: "جميع الحالات",
      statisticRange: "نطاق الإحصائية",
      allTime: "جميع الأوقات",
      startDate: "يبدأ بتاريخ",
      endDate: "ينتهي بتاريخ",
      image: "الصورة",
      sku: "SKU",
      type: "النوع",
      product: "المنتج",
      category: "القسم",
      brand: "الماركة",
      quantity: "الكمية",
      unitPrice: "سعر الوحدة",
      productOptions: "خيارات المنتج",
      noResults: "لا توجد نتائج !",
      showing: "عرض",
      to: "الى",
      of: "من",
      pages: "صفحات",
      clearTracking: "مسح التتبع",
      scope: "نطاق الإحصائية",
      ipAddress: "آي بي",
      page: "الصفحة",
      pageUrl: "رابط الصفحة",
      referrer: "الموقع القادم منه",
      clickCount: "وقت النقر",
      visitDate: "تاريخ الزيارة",
      notes: "ملاحظات",
      addToHistory: "اضافة إلى السجل",
      description: "الوصف",
      amount: "المبلغ",
      addBalance: "إضافة رصيد للعميل",
      edit: "تعديل",
      delete: "حذف",
      save: "حفظ",
      cancel: "إلغاء",
      confirmDelete: "هل أنت متأكد من الحذف؟",
      updatedSuccessfully: "تم التحديث بنجاح",
      deletedSuccessfully: "تم الحذف بنجاح",
      operationFailed: "فشلت العملية",
      points: "النقاط",
      addRewardPoints: "إضافة نقاط مكافآت",
      accountCount: "عدد الحسابات لهذا العميل",
      registrationDate: "تاريخ التسجيل",
      addAddresses: "العناوين",
      addAddress: "إضافة عنوان",
      editAddress: "تعديل العنوان",
      addressLabel: "تسمية العنوان",
      addressLabelPh: "المنزل، العمل…",
      addressFullName: "الاسم الكامل",
      addressPhone: "رقم الهاتف",
      addressLine: "العنوان التفصيلي",
      addressCity: "المدينة",
      addressCountry: "الدولة",
      addressZip: "الرمز البريدي",
      addressIsDefault: "العنوان الافتراضي",
      addressMakeDefault: "اجعله افتراضياً",
      addressDefaultBadge: "الافتراضي",
      noAddresses: "لا توجد عناوين محفوظة لهذا العميل",
      addressDeleted: "تم حذف العنوان",
      addressSaved: "تم حفظ العنوان",
    },
    customerGroups: {
      title: "مجموعات العملاء",
      groupList: "قائمة المجموعات",
      addGroup: "إضافة مجموعة",
      editGroup: "تعديل المجموعة",
      newGroup: "مجموعة جديدة",
      nameEn: "الاسم (EN)",
      nameAr: "الاسم (AR)",
      nameArPlaceholder: "اسم المجموعة بالعربية",
      descEn: "الوصف (EN)",
      descAr: "الوصف (AR)",
      descArPlaceholder: "الوصف بالعربية",
      discount: "الخصم (%)",
      sortOrder: "ترتيب العرض",
      isDefault: "المجموعة الافتراضية",
      isDefaultHint: "يتم تعيين العملاء الجدد تلقائياً لهذه المجموعة",
      status: "الحالة",
      active: "نشط",
      inactive: "غير نشط",
      name: "الاسم",
      customers: "العملاء",
      actions: "الإجراءات",
      groupCreated: "تم إنشاء المجموعة بنجاح.",
      groupUpdated: "تم تحديث المجموعة بنجاح.",
      groupDeleted: "تم حذف المجموعة.",
      saveFailed: "فشل حفظ المجموعة.",
      noGroups: "لا توجد مجموعات عملاء.",
      autoAssign: "تعيين تلقائي",
      autoAssignTitle: "تعيين العملاء تلقائياً للمجموعات",
      autoAssignDesc: "تعيين العملاء تلقائياً للمجموعات بناءً على القواعد المحددة.",
      autoAssignBtn: "تشغيل التعيين التلقائي",
      autoAssignSuccess: "تم تعيين العملاء تلقائياً للمجموعات.",
      autoAssignFailed: "فشل تشغيل التعيين التلقائي.",
      rules: "القواعد",
      addRule: "إضافة قاعدة",
      ruleType: "الشرط",
      operator: "العامل",
      value: "القيمة",
      deleteRule: "حذف القاعدة",
      ruleCreated: "تم إنشاء القاعدة.",
      ruleDeleted: "تم حذف القاعدة.",
      noRules: "لا توجد قواعد محددة لهذه المجموعة.",
      ruleTypes: {
        order_count: "عدد الطلبات",
        total_spent: "إجمالي المبلغ المنفق",
        days_since_last_order: "أيام منذ آخر طلب",
        days_since_registration: "أيام منذ التسجيل",
        avg_order_value: "متوسط قيمة الطلب",
      },
      operators: {
        gte: "أكبر من أو يساوي (>=)",
        lte: "أقل من أو يساوي (<=)",
        gt: "أكبر من (>)",
        lt: "أقل من (<)",
        eq: "يساوي (=)",
      },
    },
    customerFields: {
      title: "حقول العملاء",
      fieldList: "قائمة الحقول",
      addField: "إضافة حقل",
      editField: "تعديل الحقل",
      newField: "حقل جديد",
      nameEn: "الاسم (EN)",
      nameAr: "الاسم (AR)",
      nameArPlaceholder: "اسم الخانة بالعربية",
      fieldType: "نوع الحقل",
      options: "الخيارات",
      optionsHint: "قيم مفصولة بفاصلة (لنوع القائمة المنسدلة)",
      required: "مطلوب",
      sortOrder: "ترتيب العرض",
      status: "الحالة",
      active: "نشط",
      inactive: "غير نشط",
      name: "الاسم",
      type: "النوع",
      actions: "الإجراءات",
      fieldCreated: "تم إنشاء الحقل بنجاح.",
      fieldUpdated: "تم تحديث الحقل بنجاح.",
      fieldDeleted: "تم حذف الحقل.",
      saveFailed: "فشل حفظ الحقل.",
      noFields: "لا توجد حقول مخصصة.",
      fieldTypes: {
        text: "نص",
        textarea: "منطقة نص",
        select: "قائمة منسدلة",
        checkbox: "مربع اختيار",
        date: "تاريخ",
        number: "رقم",
      },
    },
    coupons: {
      title: "الكوبونات",
      createCoupon: "إنشاء كوبون",
      editCoupon: "تعديل الكوبون",
      newCoupon: "كوبون جديد",
      code: "الكود",
      type: "النوع",
      percentage: "نسبة مئوية",
      fixedAmount: "مبلغ ثابت",
      value: "القيمة",
      minOrder: "الحد الأدنى للطلب ($)",
      startDate: "تاريخ البداية",
      endDate: "تاريخ الانتهاء",
      maxUses: "الحد الأقصى للاستخدام",
      status: "الحالة",
      discount: "الخصم",
      usage: "الاستخدام",
      validUntil: "صالح حتى",
      actions: "الإجراءات",
      couponUpdated: "تم تحديث الكوبون",
      couponCreated: "تم إنشاء الكوبون",
      couponDeleted: "تم حذف الكوبون",
      statusExpired: "منتهي الصلاحية",
      statusNotStarted: "لم يبدأ بعد",
      statusUsedUp: "نفد الاستخدام",
      errorExpired: "انتهت صلاحية الكوبون",
      errorNotFound: "الكوبون غير موجود",
      errorNotActive: "الكوبون غير نشط",
      searchPlaceholder: "ابحث برمز الكوبون...",
      filterAll: "الكل",
      filterStatus: "الحالة",
      filterType: "النوع",
      statusActive: "نشط",
      statusInactive: "غير نشط",
      noResults: "لا توجد كوبونات مطابقة",
      showing: "عرض",
      of: "من",
      page: "صفحة",
      previous: "السابق",
      next: "التالي",
      sortAsc: "تصاعدي",
      sortDesc: "تنازلي",
      reset: "إعادة تعيين",
      errorUsageLimit: "تم استنفاذ عدد مرات استخدام الكوبون",
      errorMinAmount: "الحد الأدنى للطلب هو",
      appliesTo: "ينطبق على",
      appliesToAll: "جميع المنتجات",
      appliesToSpecific: "تصنيفات محددة",
      applicableCategories: "التصنيفات المؤهلة",
      excludedCategories: "تصنيفات مستثناة",
      selectCategories: "اختر التصنيفات",
      selectCategoriesExclude: "اختر التصنيفات المستثناة",
      noEligibleItems: "لا توجد منتجات مؤهلة لهذا الكوبون",
      image: "صورة الكوبون",
      imageHelp: "تظهر للعميل عند تطبيق الكوبون أو في صفحة العروض",
      uploadImage: "رفع صورة",
      removeImage: "إزالة الصورة",
      uploading: "جارٍ الرفع…",
      descriptionAr: "الوصف (عربي)",
      descriptionEn: "الوصف (إنجليزي)",
      descriptionPlaceholderAr: "مثال: خصم خاص بمناسبة العيد",
      descriptionPlaceholderEn: "e.g. Special Eid discount",
      termsAr: "شروط الاستخدام (عربي)",
      termsEn: "شروط الاستخدام (إنجليزي)",
      termsPlaceholderAr: "مثال: لا يُجمع مع عروض أخرى — صالح لأول طلب فقط",
      termsPlaceholderEn: "e.g. Cannot be combined with other offers — first order only",
      sectionBasics: "البيانات الأساسية",
      sectionContent: "المحتوى والعرض",
      sectionScope: "نطاق التطبيق",
      sectionRestrictions: "قيود إضافية",
      maxDiscountAmount: "الحد الأقصى لقيمة الخصم",
      maxDiscountHelp: "يُطبَّق فقط على خصم النسبة المئوية — اتركه فارغًا لعدم وجود سقف",
      requiresSignIn: "يشترط تسجيل الدخول",
      requiresSignInHelp: "لن يُقبل الكوبون من الزوار غير المسجّلين",
      firstOrderOnly: "صالح لأول طلب فقط",
      firstOrderOnlyHelp: "لن يُقبل الكوبون إذا كان لدى العميل أي طلبات سابقة",
      customerGroups: "مجموعات العملاء المؤهّلة",
      customerGroupsHelp: "اتركها فارغة ليُتاح لجميع العملاء",
      selectCustomerGroups: "اختر المجموعات",
      errorRequiresSignIn: "يجب تسجيل الدخول لاستخدام هذا الكوبون",
      errorWrongGroup: "هذا الكوبون غير متاح لمجموعتك",
      errorFirstOrderOnly: "هذا الكوبون صالح لأول طلب فقط",
    },
    banners: {
      title: "البانرات",
      addBanner: "إضافة بانر",
      editBanner: "تعديل البانر",
      newBanner: "بانر جديد",
      titleEn: "العنوان (EN)",
      titleAr: "العنوان (AR)",
      titleArPlaceholder: "عنوان البانر بالعربية",
      subtitleEn: "العنوان الفرعي (EN)",
      subtitleAr: "العنوان الفرعي (AR)",
      subtitleArPlaceholder: "العنوان الفرعي بالعربية",
      bannerImage: "صورة البانر",
      linkUrl: "رابط URL (اختياري)",
      sortOrder: "ترتيب العرض",
      status: "الحالة",
      preview: "المعاينة",
      titleCol: "العنوان",
      link: "الرابط",
      actions: "الإجراءات",
      bannerUpdated: "تم تحديث البانر",
      bannerCreated: "تم إنشاء البانر",
      bannerDeleted: "تم حذف البانر",
      saveFailed: "فشل حفظ البانر",
    },
    brands: {
      title: "الماركات",
      subtitle: "إدارة الماركات والشركات المصنعة",
      addBrand: "إضافة علامة تجارية",
      editBrand: "تعديل الماركة",
      newBrand: "علامة تجارية جديدة",
      nameEn: "الاسم (EN) *",
      nameAr: "الاسم (AR)",
      nameArPlaceholder: "اسم الماركة بالعربية",
      nameEnPlaceholder: "مثال: Apple، Samsung، Nike",
      descEn: "الوصف (EN)",
      descAr: "الوصف (AR)",
      descEnPlaceholder: "وصف مختصر للعلامة التجارية",
      descArPlaceholder: "وصف الماركة بالعربية",
      brandLogo: "شعار الماركة",
      websiteUrl: "رابط الموقع",
      websitePlaceholder: "https://example.com",
      cancel: "إلغاء",
      update: "تحديث",
      create: "إنشاء",
      logo: "الشعار",
      name: "الاسم",
      description: "الوصف",
      website: "الموقع",
      products: "المنتجات",
      actions: "الإجراءات",
      visit: "زيارة",
      noBrands: "لا توجد علامات تجارية بعد. اضغط \"إضافة علامة تجارية\" لإنشاء واحدة.",
      brandUpdated: "تم تحديث الماركة",
      brandCreated: "تم إنشاء الماركة",
      brandDeleted: "تم حذف الماركة",
      deleteConfirm: "هل أنت متأكد؟ سيتم فصل المنتجات عن هذه الماركة.",
    },
    returns: {
      title: "المرتجعات",
      subtitle: "إدارة طلبات الإرجاع والاسترداد",
      allStatuses: "جميع الحالات",
      pending: "قيد الانتظار",
      approved: "موافق عليه",
      rejected: "مرفوض",
      completed: "مكتمل",
      returnNumber: "رقم المرتجع",
      orderNumber: "رقم الطلب",
      customer: "العميل",
      reason: "السبب",
      refund: "الاسترداد",
      status: "الحالة",
      date: "التاريخ",
      actions: "الإجراءات",
      view: "عرض",
      loadingReturns: "جاري تحميل المرتجعات...",
      noReturns: "لا توجد طلبات إرجاع",
      returnDetails: "تفاصيل المرتجع",
      order: "الطلب:",
      statusLabel: "الحالة:",
      customerLabel: "العميل:",
      emailLabel: "البريد:",
      requested: "تاريخ الطلب:",
      refundAmount: "مبلغ الاسترداد:",
      reasonLabel: "السبب",
      customerNotes: "ملاحظات العميل",
      itemsToReturn: "المنتجات للإرجاع",
      product: "المنتج",
      qty: "الكمية",
      price: "السعر",
      adminNotes: "ملاحظات المشرف",
      updateStatus: "تحديث الحالة",
      newStatus: "الحالة الجديدة",
      selectStatus: "اختر الحالة",
      approve: "موافقة",
      reject: "رفض",
      completeRefund: "إتمام (استرداد)",
      refundAmountLabel: "مبلغ الاسترداد ($)",
      addNotes: "أضف ملاحظات حول هذا المرتجع...",
      close: "إغلاق",
      statusUpdated: "تم تحديث حالة المرتجع بنجاح.",
      updateFailed: "فشل تحديث حالة المرتجع.",
      page: "صفحة",
      of: "من",
      total: "إجمالي",
    },
    settings: {
      title: "إعدادات المتجر",
      generalInfo: "المعلومات العامة",
      storeName: "اسم المتجر",
      logoUrl: "رابط الشعار",
      storeDescription: "وصف المتجر",
      contactDetails: "بيانات الاتصال",
      supportEmail: "بريد الدعم",
      phoneNumber: "رقم الهاتف",
      physicalAddress: "العنوان الفعلي",
      financials: "المالية والشحن",
      currencyCode: "رمز العملة (مثال: USD)",
      currencySymbol: "رمز العملة (مثال: $)",
      taxRate: "نسبة الضريبة (%)",
      flatShippingRate: "رسوم الشحن الثابتة",
      freeShippingThreshold: "حد الشحن المجاني (اختياري)",
      saveSettings: "حفظ الإعدادات",
      settingsUpdated: "تم تحديث الإعدادات بنجاح.",
      loadingSettings: "جاري تحميل الإعدادات...",
    },
    reviews: {
      title: "التقييمات",
      subtitle: "إدارة تقييمات المنتجات والتصنيفات",
      allStatuses: "جميع الحالات",
      pending: "قيد الانتظار",
      approved: "موافق عليه",
      rejected: "مرفوض",
      searchReviews: "البحث في التقييمات...",
      product: "المنتج",
      customer: "العميل",
      rating: "التقييم",
      comment: "التعليق",
      status: "الحالة",
      date: "التاريخ",
      actions: "الإجراءات",
      approve: "موافقة",
      reject: "رفض",
      delete: "حذف",
      noReviews: "لا توجد تقييمات.",
      loadingReviews: "جاري تحميل التقييمات...",
      reviewApproved: "تمت الموافقة على التقييم.",
      reviewRejected: "تم رفض التقييم.",
      reviewDeleted: "تم حذف التقييم.",
      deleteConfirm: "هل أنت متأكد من حذف هذا التقييم؟",
      stars: "نجوم",
    },
    pages: {
      title: "صفحات المعلومات",
      subtitle: "إدارة صفحات المحتوى الثابت (حول المتجر، الشروط، الخصوصية، إلخ)",
      addPage: "إضافة صفحة",
      editPage: "تعديل الصفحة",
      newPage: "صفحة جديدة",
      titleEn: "العنوان (EN)",
      titleAr: "العنوان (AR)",
      titleArPlaceholder: "عنوان الصفحة بالعربية",
      slug: "الرابط (URL)",
      slugPlaceholder: "مثال: about-us, terms, privacy",
      contentEn: "المحتوى (EN)",
      contentAr: "المحتوى (AR)",
      contentArPlaceholder: "محتوى الصفحة بالعربية",
      sortOrder: "ترتيب العرض",
      status: "الحالة",
      pageName: "عنوان الصفحة",
      url: "الرابط",
      actions: "الإجراءات",
      pageUpdated: "تم تحديث الصفحة بنجاح.",
      pageCreated: "تم إنشاء الصفحة بنجاح.",
      pageDeleted: "تم حذف الصفحة بنجاح.",
      saveFailed: "فشل حفظ الصفحة.",
      noPages: "لا توجد صفحات بعد.",
      deleteConfirm: "هل أنت متأكد من حذف هذه الصفحة؟",
    },
    reports: {
      title: "التقارير",
      subtitle: "تقارير المبيعات والتحليلات",
      salesReport: "تقرير المبيعات",
      totalSales: "إجمالي المبيعات",
      totalOrders: "إجمالي الطلبات",
      avgOrderValue: "متوسط قيمة الطلب",
      topSellingProducts: "المنتجات الأكثر مبيعاً",
      salesByCategory: "المبيعات حسب الفئة",
      monthlySales: "المبيعات الشهرية",
      month: "الشهر",
      revenue: "الإيرادات",
      orders: "الطلبات",
      product: "المنتج",
      unitsSold: "الوحدات المباعة",
      category: "الفئة",
      noData: "لا توجد بيانات لهذه الفترة.",
      last30Days: "آخر 30 يوم",
      last90Days: "آخر 90 يوم",
      last12Months: "آخر 12 شهر",
      thisYear: "هذا العام",
      sales: "المبيعات",
      salesSubtitle: "تحليلات الإيرادات والطلبات والمدفوعات",
      products: "المنتجات",
      productsSubtitle: "أداء المنتجات ومستويات المخزون والتقييمات",
      customers: "العملاء",
      customersSubtitle: "نشاط العملاء والتسجيلات والإنفاق",
      marketing: "التسويق",
      marketingSubtitle: "استخدام القسائم وأداء الحملات",
      ordersReport: "الطلبات",
      ordersSubtitle: "حالات الطلبات والمدن والاتجاهات اليومية",
      returnsReport: "المرتجعات",
      returnsSubtitle: "معدلات الإرجاع والأسباب وتحليلات الاسترداد",
      totalDiscount: "إجمالي الخصومات",
      totalShipping: "إجمالي الشحن",
      totalTax: "إجمالي الضريبة",
      byPaymentMethod: "حسب طريقة الدفع",
      paymentMethod: "طريقة الدفع",
      count: "العدد",
      total: "الإجمالي",
      lowStock: "مخزون منخفض",
      outOfStock: "نفد من المخزون",
      topRated: "الأعلى تقييماً",
      activeProducts: "المنتجات النشطة",
      avgPrice: "متوسط السعر",
      stock: "المخزون",
      rating: "التقييم",
      reviewCount: "المراجعات",
      price: "السعر",
      topCustomers: "أفضل العملاء",
      newThisMonth: "جدد هذا الشهر",
      newLastMonth: "جدد الشهر الماضي",
      noOrderCustomers: "عملاء بدون طلبات",
      customerRegistrations: "تسجيلات العملاء",
      customer: "العميل",
      email: "البريد الإلكتروني",
      totalSpent: "إجمالي الإنفاق",
      lastOrder: "آخر طلب",
      couponUsage: "استخدام القسائم",
      totalCoupons: "إجمالي القسائم",
      activeCoupons: "القسائم النشطة",
      totalUsed: "إجمالي المستخدمة",
      ordersWithCoupons: "طلبات بقسائم",
      totalDiscountGiven: "إجمالي الخصومات الممنوحة",
      couponCode: "رمز القسيمة",
      type: "النوع",
      value: "القيمة",
      used: "مستخدم",
      maxUses: "الحد الأقصى",
      status: "الحالة",
      statusBreakdown: "توزيع الحالات",
      paymentStatusBreakdown: "حالة الدفع",
      todayOrders: "طلبات اليوم",
      thisMonthOrders: "هذا الشهر",
      pendingOrders: "طلبات معلقة",
      ordersByCity: "الطلبات حسب المدينة",
      city: "المدينة",
      dailyOrders: "الطلبات اليومية (آخر 30 يوم)",
      totalReturns: "إجمالي المرتجعات",
      totalRefunded: "إجمالي المسترد",
      pendingReturns: "مرتجعات معلقة",
      approvedReturns: "مرتجعات موافق عليها",
      returnRate: "معدل الإرجاع",
      thisMonthReturns: "مرتجعات هذا الشهر",
      recentReturns: "آخر المرتجعات",
      topReturnReasons: "أكثر أسباب الإرجاع",
      returnNumber: "رقم المرتجع",
      reason: "السبب",
      refundAmount: "مبلغ الاسترداد",
      date: "التاريخ",
      unlimited: "غير محدود",
      noReturns: "لا توجد مرتجعات حتى الآن.",
      noCoupons: "لا توجد قسائم حتى الآن.",
      couponRate: "نسبة استخدام القسائم",
    },
    sidebarGroups: {
      catalog: "واجهة المتجر",
      sales: "المبيعات",
      customers: "العملاء",
      marketing: "التسويق",
      content: "المحتوى",
      system: "الاعدادات",
      extensions: "الإضافات",
      blog: "المدونة",
      reports: "التقارير",
    },
    giftVouchers: {
      title: "قسائم الهدايا",
      subtitle: "إنشاء وإدارة أكواد قسائم الهدايا",
      addNew: "إضافة قسيمة هدية",
      editVoucher: "تعديل قسيمة الهدية",
      addDesc: "إنشاء كود قسيمة هدية جديد",
      editDesc: "تحديث تفاصيل قسيمة الهدية",
      code: "كود القسيمة",
      codeAutoGenerate: "اتركه فارغاً للتوليد التلقائي",
      from: "من",
      to: "إلى",
      fromName: "اسم المرسل",
      fromEmail: "بريد المرسل",
      toName: "اسم المستلم",
      toEmail: "بريد المستلم",
      amount: "المبلغ",
      balance: "الرصيد",
      status: "الحالة",
      date: "التاريخ",
      theme: "القالب",
      message: "الرسالة",
      expiresAt: "تاريخ الانتهاء",
      themeGeneral: "عام",
      themeBirthday: "عيد ميلاد",
      themeChristmas: "مناسبة",
      themeWedding: "زفاف",
      themeThankYou: "شكر",
      statusActive: "نشط",
      statusUsed: "مستخدم",
      statusExpired: "منتهي",
      statusDisabled: "معطّل",
      created: "تم إنشاء قسيمة الهدية بنجاح",
      updated: "تم تحديث قسيمة الهدية بنجاح",
      deleted: "تم حذف قسيمة الهدية",
      codeCopied: "تم نسخ كود القسيمة",
      noVouchers: "لا توجد قسائم هدايا",
      searchPlaceholder: "ابحث بالكود أو الاسم أو البريد...",
      selectAll: "تحديد الكل",
      selected: "محدد",
      bulkDelete: "حذف المحدد",
      bulkChangeStatus: "تغيير الحالة",
      bulkChangeStatusTitle: "تغيير حالة العناصر المحددة",
      bulkChangeStatusDesc: "اختر الحالة الجديدة للعناصر المحددة",
      newStatus: "الحالة الجديدة",
      bulkDeleteConfirm: "هل أنت متأكد من حذف {count} قسيمة؟ لا يمكن التراجع.",
      bulkDeleted: "تم حذف {count} قسيمة",
      bulkUpdated: "تم تحديث {count} قسيمة",
      sortAsc: "ترتيب تصاعدي",
      sortDesc: "ترتيب تنازلي",
    },
    shipments: {
      title: "الشحنات",
      subtitle: "تتبع وإدارة شحنات الطلبات",
      addNew: "إضافة شحنة",
      editShipment: "تعديل الشحنة",
      addDesc: "إنشاء شحنة جديدة لطلب",
      editDesc: "تحديث تفاصيل الشحنة",
      orderId: "رقم الطلب",
      orderIdPlaceholder: "أدخل رقم الطلب",
      orderNumber: "رقم الطلب",
      customer: "العميل",
      carrier: "شركة الشحن",
      selectCarrier: "اختر شركة الشحن",
      trackingNumber: "رقم التتبع",
      trackingPlaceholder: "أدخل رقم التتبع",
      status: "الحالة",
      shippedDate: "تاريخ الشحن",
      deliveredDate: "تاريخ التسليم",
      notes: "ملاحظات",
      statusPreparing: "جاري التحضير",
      statusShipped: "تم الشحن",
      statusInTransit: "في الطريق",
      statusDelivered: "تم التسليم",
      statusReturned: "مرتجع",
      created: "تم إنشاء الشحنة بنجاح",
      updated: "تم تحديث الشحنة بنجاح",
      deleted: "تم حذف الشحنة",
      noShipments: "لا توجد شحنات",
      searchPlaceholder: "ابحث برقم التتبع أو شركة الشحن أو الطلب...",
    },
    fileManager: {
      title: "محرر الملفات",
      subtitle: "تصفّح وحرّر الملفات في مجلد الإدارة الآمن",
      files: "الملفات",
      noFile: "لم يتم اختيار ملف",
      selectHint: "اختر ملفاً نصياً من القائمة لعرضه وتحريره",
      empty: "هذا المجلد فارغ",
      refresh: "تحديث",
      newFolder: "مجلد جديد",
      newFile: "ملف جديد",
      upload: "رفع ملف",
      save: "حفظ",
      saved: "تم حفظ الملف بنجاح",
      created: "تم إنشاء الملف",
      folderCreated: "تم إنشاء المجلد",
      deleted: "تم الحذف",
      renamed: "تمت إعادة التسمية",
      uploaded: "تم رفع الملف",
      up: "للأعلى",
      newFilePrompt: "اسم الملف الجديد:",
      newFolderPrompt: "اسم المجلد الجديد:",
      renamePrompt: "الاسم الجديد:",
      notEditable: "هذا الملف غير قابل للتحرير (نوع غير نصي أو حجم كبير)",
      cancel: "إلغاء",
      deleteTitle: "تأكيد الحذف",
      deleteFileMsg: "سيتم حذف الملف \"{name}\" نهائياً. لا يمكن التراجع عن هذا الإجراء.",
      deleteFolderMsg: "سيتم حذف المجلد \"{name}\" وكل الملفات بداخله نهائياً. لا يمكن التراجع عن هذا الإجراء.",
      confirmDelete: "نعم، احذف",
      saveTitle: "تأكيد حفظ التعديلات",
      saveMsg: "سيتم استبدال محتوى الملف \"{name}\" بالمحتوى الجديد. هل تريد المتابعة؟",
      confirmSave: "نعم، احفظ",
    },
    extensions: {
      title: "الإضافات",
      subtitle: "إدارة التكاملات وبوابات الدفع والشحن والتحليلات والوحدات",
      allTypes: "جميع الأنواع",
      payment: "طرق الدفع",
      shipping: "طرق الشحن",
      email: "البريد الإلكتروني",
      whatsapp: "واتساب / رسائل",
      analytics: "التحليلات والتتبع",
      module: "الوحدات",
      integration: "جهات الربط",
      enabled: "مفعّل",
      disabled: "معطّل",
      enable: "تفعيل",
      disable: "تعطيل",
      edit: "تعديل",
      settings: "الإعدادات",
      save: "حفظ الإعدادات",
      cancel: "إلغاء",
      status: "الحالة",
      name: "الاسم",
      type: "النوع",
      actions: "الإجراءات",
      noExtensions: "لا توجد إضافات في هذه الفئة.",
      loadingExtensions: "جاري تحميل الإضافات...",
      extensionUpdated: "تم تحديث الإضافة بنجاح.",
      extensionSaved: "تم حفظ إعدادات الإضافة.",
      saveFailed: "فشل حفظ إعدادات الإضافة.",
      testMode: "وضع الاختبار",
      liveMode: "الوضع الحقيقي",
      apiKey: "مفتاح API",
      secretKey: "المفتاح السري",
      backToList: "العودة للإضافات",
      generalSettings: "الإعدادات العامة",
      notificationSettings: "إعدادات الإشعارات",
      orderConfirmation: "تأكيد الطلب",
      orderStatusUpdate: "تحديث حالة الطلب",
      contactFormReply: "رد نموذج الاتصال",
      contactFormNotify: "إشعار نموذج الاتصال",
      fromEmail: "البريد المرسل",
      fromName: "اسم المرسل",
      adminPhone: "رقم هاتف المدير",
      phoneNumberId: "معرّف رقم واتساب (Phone Number ID)",
      wabaId: "معرّف حساب أعمال واتساب (WABA ID)",
      verifyToken: "رمز التحقّق من الـWebhook",
      publishableKey: "المفتاح العام",
      webhookSecret: "مفتاح Webhook",
      clientId: "معرف العميل",
      clientSecret: "المفتاح السري للعميل",
      accessToken: "رمز الوصول",
      merchantCertificate: "شهادة التاجر",
      merchantDomain: "نطاق التاجر",
      apiToken: "رمز API",
      notificationToken: "رمز الإشعارات",
      merchantUrl: "رابط التاجر",
      merchantCode: "رمز التاجر",
      paymentType: "نوع الدفع",
      measurementId: "معرف القياس (G-XXXXXXXXXX)",
      propertyId: "معرف الموقع (Property ID) — مثل 123456789",
      pixelId: "معرف البيكسل",
      containerId: "معرف الحاوية",
      trackPageViews: "تتبع مشاهدات الصفحات",
      trackEvents: "تتبع الأحداث",
      trackPurchases: "تتبع المشتريات",
      trackAddToCart: "تتبع الإضافة للسلة",
      bankName: "اسم البنك",
      accountName: "اسم صاحب الحساب",
      accountNumber: "رقم الحساب",
      iban: "رقم الآيبان",
      instructions: "التعليمات",
      instructionsAr: "التعليمات (عربي)",
      shippingCost: "تكلفة الشحن",
      freeAbove: "شحن مجاني فوق",
      estimatedDays: "أيام التوصيل المتوقعة",
      address: "العنوان",
      workingHours: "ساعات العمل",
      fee: "رسوم الخدمة",
      provider: "المزود",
      widgetCode: "كود الأداة",
      showPopup: "إظهار النافذة المنبثقة",
      popupDelay: "تأخير النافذة (ثواني)",
      discountCode: "كود الخصم",
      daysAfterDelivery: "الأيام بعد التوصيل",
      sendViaEmail: "إرسال عبر البريد",
      sendViaWhatsApp: "إرسال عبر واتساب",
      entityId: "معرف الكيان",
      merchantId: "معرف التاجر",
      currency: "العملة",
      apiId: "معرف API (API ID)",
      accessCode: "رمز الوصول (Access Code)",
      shaRequestPhrase: "عبارة SHA للطلب (SHA Request Phrase)",
      shaResponsePhrase: "عبارة SHA للرد (SHA Response Phrase)",
      shaType: "نوع SHA (SHA-256 / SHA-512)",
      displayTitle: "اسم طريقة الدفع",
      routingWeightPct: "نسبة التوجيه (%) — حصة هذه البوابة من المعاملات عند تفعيل أكثر من بوابة بطاقات",
      installed: "الإضافات المثبتة",
      extensionTypes: "أنواع الإضافات",
      chooseType: "اختر نوع الإضافة",
      addExtension: "إضافة جديدة",
      deleteExtension: "حذف الإضافة",
      deleteConfirm: "هل أنت متأكد من حذف هذه الإضافة؟",
      extensionDeleted: "تم حذف الإضافة.",
      extensionCode: "كود الإضافة",
      extensionName: "اسم الإضافة (EN)",
      extensionNameAr: "اسم الإضافة (AR)",
      extensionDesc: "الوصف (EN)",
      extensionDescAr: "الوصف (AR)",
    },
    marketingTracking: {
      title: "تتبع نظام التسويق",
      campaigns: "حملات",
      campaignName: "اسم الحملة",
      trackingCode: "شفرة التتبع",
      clicks: "النقرات",
      orders: "الطلبات",
      totalSales: "إجمالي المبيعات",
      totalSalesHint: "مجموع قيمة الطلبات المؤكدة (باستثناء الملغاة والمستردة) المرتبطة بشفرة هذه الحملة كقسيمة خصم.",
      startDate: "تاريخ البداية",
      edit: "تحرير",
      filter: "تصفية",
      clearFilters: "مسح التصفية",
      sortBy: "الترتيب حسب",
      sortDir: "الاتجاه",
      sortAsc: "تصاعدي",
      sortDesc: "تنازلي",
      sortName: "الاسم (أبجدياً)",
      sortCode: "شفرة التتبع",
      sortClicks: "النقرات",
      sortOrders: "الطلبات",
      sortTotalSales: "إجمالي المبيعات",
      sortStartDate: "تاريخ البداية",
      trackingLink: "رابط التتبع",
      copyLink: "نسخ الرابط",
      linkCopied: "تم نسخ الرابط",
      copyFailed: "تعذّر نسخ الرابط",
      noCampaigns: "لا توجد حملات تسويقية.",
      addCampaign: "إضافة حملة",
      editCampaign: "تعديل الحملة",
      description: "الوصف",
      created: "تم إنشاء الحملة بنجاح",
      updated: "تم تحديث الحملة بنجاح",
      deleted: "تم حذف الحملة بنجاح",
      confirmDelete: "هل أنت متأكد من حذف هذه الحملة؟",
    },
    googleShopping: {
      title: "Google Shopping",
      settings: "الإعدادات",
      products: "المنتجات",
      merchantId: "معرف التاجر",
      targetCountry: "الدولة المستهدفة",
      currency: "العملة",
      contentLanguage: "لغة المحتوى",
      autoSync: "مزامنة تلقائية",
      syncInterval: "فترة المزامنة",
      syncIntervals: { "1": "كل ساعة", "2": "كل ساعتين", "4": "كل 4 ساعات", "6": "كل 6 ساعات", "12": "كل 12 ساعة", "24": "كل 24 ساعة", "48": "كل 48 ساعة" },
      includeOutOfStock: "تضمين نفاد المخزون",
      feedStatus: "حالة التغذية",
      active: "نشط",
      inactive: "غير نشط",
      lastSynced: "آخر مزامنة",
      never: "لم تتم",
      settingsSaved: "تم حفظ الإعدادات بنجاح.",
      settingsFailed: "فشل حفظ الإعدادات.",
      feedUrl: "رابط التغذية",
      connectionMethod: "طريقة الربط",
      xmlFeed: "XML Feed (جلب دوري)",
      xmlFeedDesc: "يُولَّد رابط تغذية تنسخه في Google Merchant Center، وتقوم Google بجلبه تلقائياً وفق الجدول الذي تحدده.",
      xmlFeedStep1: "انسخ رابط التغذية أدناه",
      xmlFeedStep2: "افتح Google Merchant Center ← Products ← Data Sources ← Add Data Source",
      xmlFeedStep3: "اختر: المملكة العربية السعودية، اللغة: العربية أو الإنجليزية",
      xmlFeedStep4: "اختر: Scheduled fetch — الصق الرابط",
      xmlFeedStep5: "اضبط جدول الجلب ليطابق فترة المزامنة أعلاه",
      localInventoryFeedTitle: "تغذية المخزون المحلي (Local Inventory Ads)",
      localInventoryFeedDesc: "مطلوب لإعلانات المخزون المتاح في المتجر. أضف هذا الرابط كمصدر بيانات تكميلي من نوع «Local Products Inventory» في Google Merchant Center.",
      localInventoryFeedUrl: "رابط تغذية المخزون المحلي",
      storeCode: "رمز المتجر (Store Code)",
      storeCodeDesc: "أدخل رمز المتجر المسجّل في Business Profile. يُستخدم للربط بين المنتجات ومخزون المتجر الفعلي أو الإلكتروني.",
      storeCodePlaceholder: "مثال: ONLINE أو رمز متجرك",
      localInventoryStep1: "أدخل رمز المتجر أعلاه واحفظ الإعدادات",
      localInventoryStep2: "سجّل نفس الرمز في Google My Business / Business Profile",
      localInventoryStep3: "افتح Google Merchant Center ← Products ← Data Sources ← Add Data Source",
      localInventoryStep4: "اختر نوع «Local Products Inventory» والصق الرابط",
      contentApi: "Content API (دفع مباشر)",
      contentApiDesc: "يُرسَل كتالوج المنتجات مباشرةً إلى Google Merchant Center تلقائياً دون الحاجة إلى رابط تغذية. يتطلب بيانات OAuth2 من Google Cloud Console.",
      contentApiClientId: "OAuth2 Client ID",
      contentApiClientSecret: "OAuth2 Client Secret",
      contentApiHint: "أنشئ بيانات OAuth2 في Google Cloud Console ← APIs & Services ← Credentials، ثم فعّل Content API for Shopping.",
      connectWithGoogle: "ربط بـ Google",
      oauthConnected: "مرتبط بـ Google ✓",
      oauthConnectedSince: "مرتبط منذ",
      oauthDisconnect: "قطع الاتصال",
      oauthRedirectUri: "رابط إعادة التوجيه (أضفه في Google Cloud Console)",
      oauthConnectStep1: "احفظ الـ Client ID والـ Client Secret أعلاه",
      oauthConnectStep2: "في Google Cloud Console ← Credentials ← OAuth Client أضف رابط إعادة التوجيه الأخضر أدناه تحت Authorized redirect URIs",
      oauthConnectStep3: "اضغط «ربط بـ Google» ووافق على الصلاحيات",
      oauthConnectSuccess: "تم ربط الحساب بـ Google بنجاح",
      oauthConnectError: "فشل ربط الحساب بـ Google",
      syncPushed: "تم رفع {{count}} منتج إلى Google Merchant Center",
      syncErrors: "فشل رفع {{count}} منتج",
      addProduct: "إضافة منتج",
      productName: "المنتج",
      googleCategory: "فئة جوجل",
      condition: "الحالة",
      availability: "التوفر",
      excluded: "مستبعد",
      included: "مضمّن",
      status: "الحالة",
      actions: "الإجراءات",
      noProducts: "لا توجد منتجات في تغذية Google Shopping.",
      productAdded: "تمت إضافة المنتج للتغذية.",
      productRemoved: "تم إزالة المنتج من التغذية.",
      conditions: {
        new: "جديد",
        refurbished: "مجدد",
        used: "مستعمل",
      },
      availabilities: {
        in_stock: "متوفر",
        out_of_stock: "غير متوفر",
        preorder: "طلب مسبق",
      },
      searchPlaceholder: "بحث في المنتجات...",
      selectedCount: "{n} محدد",
      bulkEditSelected: "تعديل المحدد",
      includeSelected: "تفعيل المحدد",
      excludeSelected: "استبعاد المحدد",
      removeSelected: "حذف المحدد",
      bulkActionApplied: "تم تطبيق الإجراء على {n} منتج",
      bulkEditApplied: "تم تعديل {n} منتج",
      bulkEditFailed: "فشل التعديل الجماعي",
      pickFieldFirst: "اختر حقلاً واحداً على الأقل لتعديله",
      filterAll: "الكل",
      filterNoCategory: "— بدون فئة —",
      resultsCount: "{n} نتيجة",
      clearFilters: "مسح الفلاتر",
      bulkEditTitle: "تعديل جماعي على {n} منتج",
      bulkEditHint: "اترك أي حقل فارغاً إذا لم ترد تغييره. سيتم تطبيق التغييرات على المنتجات المحدّدة فقط.",
      leaveUnchanged: "بدون تغيير",
      applyBtn: "تطبيق",
      cancelBtn: "إلغاء",
      hiddenSelectionWarning: "هناك {n} عنصر محدد غير ظاهر بسبب الفلاتر — سيتأثر بالإجراء.",
    },
    facebookCatalog: {
      title: "كتالوج فيسبوك",
      settings: "الإعدادات",
      products: "المنتجات",
      businessId: "معرف الأعمال (Business ID)",
      catalogId: "معرف الكتالوج (Catalog ID)",
      pixelId: "معرف البكسل (Pixel ID)",
      targetCountry: "الدولة المستهدفة",
      currency: "العملة",
      contentLanguage: "لغة المحتوى",
      autoSync: "مزامنة تلقائية",
      syncInterval: "فترة المزامنة (ساعات)",
      includeOutOfStock: "تضمين نفاد المخزون",
      feedStatus: "حالة التغذية",
      active: "نشط",
      inactive: "غير نشط",
      lastSynced: "آخر مزامنة",
      never: "لم تتم",
      settingsSaved: "تم حفظ الإعدادات بنجاح.",
      settingsFailed: "فشل حفظ الإعدادات.",
      feedUrl: "رابط التغذية",
      addProduct: "إضافة منتج",
      productName: "المنتج",
      fbCategory: "فئة فيسبوك",
      condition: "الحالة",
      availability: "التوفر",
      excluded: "مستبعد",
      included: "مضمّن",
      status: "الحالة",
      actions: "الإجراءات",
      noProducts: "لا توجد منتجات في كتالوج فيسبوك.",
      productAdded: "تمت إضافة المنتج للكتالوج.",
      productRemoved: "تم إزالة المنتج من الكتالوج.",
      conditions: { new: "جديد", refurbished: "مجدد", used: "مستعمل" },
      availabilities: { in_stock: "متوفر", out_of_stock: "غير متوفر", preorder: "طلب مسبق" },
      searchPlaceholder: "بحث في المنتجات...",
      selectedCount: "{n} محدد",
      bulkEditSelected: "تعديل المحدد",
      includeSelected: "تفعيل المحدد",
      excludeSelected: "استبعاد المحدد",
      removeSelected: "حذف المحدد",
      bulkActionApplied: "تم تطبيق الإجراء على {n} منتج",
      bulkEditApplied: "تم تعديل {n} منتج",
      bulkEditFailed: "فشل التعديل الجماعي",
      pickFieldFirst: "اختر حقلاً واحداً على الأقل لتعديله",
      filterAll: "الكل",
      filterNoCategory: "— بدون فئة —",
      resultsCount: "{n} نتيجة",
      clearFilters: "مسح الفلاتر",
      bulkEditTitle: "تعديل جماعي على {n} منتج",
      bulkEditHint: "اترك أي حقل فارغاً إذا لم ترد تغييره. سيتم تطبيق التغييرات على المنتجات المحدّدة فقط.",
      leaveUnchanged: "بدون تغيير",
      applyBtn: "تطبيق",
      cancelBtn: "إلغاء",
      hiddenSelectionWarning: "هناك {n} عنصر محدد غير ظاهر بسبب الفلاتر — سيتأثر بالإجراء.",
      syncNow: "مزامنة الآن",
      addAll: "إضافة جميع المنتجات",
      addToFeed: "إضافة منتجات إلى كتالوج فيسبوك",
      defaultCategory: "فئة فيسبوك (افتراضي)",
      none: "بدون",
      noResults: "لا توجد نتائج",
      productsSelected: "{n} منتج محدد",
      cancel: "إلغاء",
      addBtn: "إضافة",
      addedSkipped: "تمت إضافة {added} منتج (تم تخطي {skipped} مكرر)",
      addFailed: "فشل الإضافة",
      addAllConfirm: "هل تريد إضافة كل المنتجات النشطة إلى كتالوج فيسبوك؟",
      addedOfTotal: "تمت إضافة {added} منتج من إجمالي {total}",
      syncedToast: "تم تحديث وقت المزامنة. ربط Facebook Graph API الفعلي سيُفعّل في خطوة لاحقة.",
      addDialogTitle: "إضافة منتجات إلى كتالوج فيسبوك",
      product: "المنتج",
      sku: "SKU",
      price: "السعر",
      pageInfo: "عرض {from}–{to} من {total} منتج",
      prev: "السابق",
      next: "التالي",
      pageOf: "صفحة {page} من {total}",
      businessIdHint: "من Meta Business Suite ← الإعدادات ← معلومات الحساب",
      catalogIdHint: "من Commerce Manager ← الكتالوج ← الإعدادات",
      feedUrlHint: "انسخ هذا الرابط وأدخله في Commerce Manager ← مصادر البيانات ← إضافة مصدر بيانات ← مجدول",
      apiNote: "ملاحظة: الربط المباشر مع Facebook Graph API سيتم تفعيله في خطوة لاحقة. حالياً النظام يولّد ملف XML Feed يمكن إضافته يدوياً في Commerce Manager.",
    },
    snapchatCatalog: {
      title: "كتالوج سناب شات",
      subtitle: "زوّد سناب شات بكتالوج منتجاتك وشغّل إعلانات الشراء",
      settings: "الإعدادات",
      products: "المنتجات",
      snapCatalogId: "معرف الكتالوج (Catalog ID)",
      snapCatalogIdHint: "من Snap Business Manager ← Catalogs ← إعدادات الكتالوج",
      businessId: "معرف الحساب التجاري (Business ID)",
      pixelId: "معرف البكسل (Pixel ID)",
      optional: "اختياري",
      targetCountry: "الدولة المستهدفة",
      currency: "العملة",
      contentLanguage: "لغة المحتوى",
      autoSync: "مزامنة تلقائية",
      syncInterval: "فترة المزامنة (ساعات)",
      includeOutOfStock: "تضمين نفاد المخزون",
      feedStatus: "حالة التغذية",
      active: "نشط",
      inactive: "غير نشط",
      lastSynced: "آخر مزامنة",
      never: "لم تتم",
      settingsSaved: "تم حفظ الإعدادات بنجاح.",
      settingsFailed: "فشل حفظ الإعدادات.",
      feedUrl: "رابط التغذية",
      feedUrlHint: "انسخ هذا الرابط وأدخله في Snap Business Manager ← Catalogs ← Import Method ← Scheduled Feed",
      howToConnect: "كيفية الربط مع Snap Business Manager:",
      step1: "افتح Snap Business Manager ← Catalogs ← أنشئ كتالوجاً جديداً",
      step2: "اختر طريقة الاستيراد: Scheduled Feed",
      step3: "أدخل رابط التغذية أعلاه وحدد جدول التحديث",
      step4: "احفظ الكتالوج وابدأ بإنشاء Collection Ads أو Dynamic Ads",
      copied: "تم نسخ الرابط",
      syncNow: "مزامنة الآن",
      syncDone: "تم تحديث وقت المزامنة.",
      addProduct: "إضافة منتج",
      addAll: "إضافة جميع المنتجات",
      addToFeed: "إضافة منتجات إلى كتالوج سناب شات",
      defaultCategory: "فئة سناب شات (افتراضي)",
      confirmAddAll: "هل تريد إضافة كل المنتجات النشطة إلى كتالوج سناب شات؟",
      addedTotal: "تمت إضافة {added} منتج من إجمالي {total}",
      addedSkipped: "تمت إضافة {added} منتج (تم تخطي {skipped} مكرر)",
      addFailed: "فشل الإضافة",
      save: "حفظ الإعدادات",
      snapCategory: "فئة سناب شات",
      condition: "الحالة",
      availability: "التوفر",
      excluded: "مستبعد",
      included: "مضمّن",
      status: "الحالة",
      actions: "الإجراءات",
      noProducts: "لا توجد منتجات في كتالوج سناب شات.",
      productAdded: "تمت إضافة المنتج للكتالوج.",
      productRemoved: "تم إزالة المنتج من الكتالوج.",
      conditions: { new: "جديد", refurbished: "مجدد", used: "مستعمل" },
      availabilities: { in_stock: "متوفر", out_of_stock: "غير متوفر", preorder: "طلب مسبق" },
      searchPlaceholder: "بحث في المنتجات...",
      selectedCount: "{n} محدد",
      bulkEditSelected: "تعديل المحدد",
      includeSelected: "تفعيل المحدد",
      excludeSelected: "استبعاد المحدد",
      removeSelected: "حذف المحدد",
      bulkActionApplied: "تم تطبيق الإجراء على {n} منتج",
      bulkEditApplied: "تم تعديل {n} منتج",
      bulkEditFailed: "فشل التعديل الجماعي",
      pickFieldFirst: "اختر حقلاً واحداً على الأقل لتعديله",
      filterAll: "الكل",
      filterNoCategory: "— بدون فئة —",
      resultsCount: "{n} نتيجة",
      clearFilters: "مسح الفلاتر",
      bulkEditTitle: "تعديل جماعي على {n} منتج",
      bulkEditHint: "اترك أي حقل فارغاً إذا لم ترد تغييره. سيتم تطبيق التغييرات على المنتجات المحدّدة فقط.",
      leaveUnchanged: "بدون تغيير",
      applyBtn: "تطبيق",
      cancelBtn: "إلغاء",
      none: "بدون",
      noResults: "لا توجد نتائج",
      productsSelected: "{n} منتج محدد",
      cancel: "إلغاء",
      addBtn: "إضافة",
      totalInFeed: "إجمالي المنتجات في الكتالوج",
      activeProducts: "منتجات مفعّلة",
      excludedProducts: "منتجات مستبعدة",
      productName: "المنتج",
      price: "السعر",
    },
    tiktokCatalog: {
      title: "كتالوج تيك توك",
      subtitle: "زوّد تيك توك بكتالوج منتجاتك وشغّل إعلانات التسوق",
      settings: "الإعدادات",
      products: "المنتجات",
      advertiserId: "معرف المعلن (Advertiser ID)",
      advertiserIdHint: "من TikTok Ads Manager ← Account Info",
      catalogId: "معرف الكتالوج (Catalog ID)",
      catalogIdHint: "من TikTok Ads Manager ← Assets ← Catalog ← إعدادات الكتالوج",
      targetCountry: "الدولة المستهدفة",
      currency: "العملة",
      contentLanguage: "لغة المحتوى",
      autoSync: "مزامنة تلقائية",
      syncInterval: "فترة المزامنة (ساعات)",
      includeOutOfStock: "تضمين نفاد المخزون",
      feedStatus: "حالة التغذية",
      active: "نشط",
      inactive: "غير نشط",
      lastSynced: "آخر مزامنة",
      never: "لم تتم",
      settingsSaved: "تم حفظ الإعدادات بنجاح.",
      settingsFailed: "فشل حفظ الإعدادات.",
      feedUrl: "رابط التغذية",
      feedUrlHint: "انسخ هذا الرابط وأدخله في TikTok Ads Manager ← Assets ← Catalog ← Data Source ← Scheduled Feed",
      howToConnect: "كيفية الربط مع TikTok Ads Manager:",
      step1: "افتح TikTok Ads Manager ← Assets ← Catalog ← Create Catalog",
      step2: "اختر Data Source ← Scheduled Feed",
      step3: "أدخل رابط التغذية أعلاه وحدد جدول التحديث",
      step4: "احفظ الكتالوج وابدأ بإنشاء حملات Shopping أو Video Shopping Ads",
      copied: "تم نسخ الرابط",
      syncNow: "مزامنة الآن",
      syncDone: "تم تحديث وقت المزامنة.",
      addProduct: "إضافة منتج",
      addAll: "إضافة جميع المنتجات",
      addToFeed: "إضافة منتجات إلى كتالوج تيك توك",
      defaultCategory: "فئة تيك توك (افتراضي)",
      confirmAddAll: "هل تريد إضافة كل المنتجات النشطة إلى كتالوج تيك توك؟",
      addedTotal: "تمت إضافة {added} منتج من إجمالي {total}",
      addedSkipped: "تمت إضافة {added} منتج (تم تخطي {skipped} مكرر)",
      addFailed: "فشل الإضافة",
      save: "حفظ الإعدادات",
      tiktokCategory: "فئة تيك توك",
      condition: "الحالة",
      availability: "التوفر",
      excluded: "مستبعد",
      included: "مضمّن",
      status: "الحالة",
      actions: "الإجراءات",
      noProducts: "لا توجد منتجات في كتالوج تيك توك.",
      productAdded: "تمت إضافة المنتج للكتالوج.",
      productRemoved: "تم إزالة المنتج من الكتالوج.",
      conditions: { new: "جديد", refurbished: "مجدد", used: "مستعمل" },
      availabilities: { in_stock: "متوفر", out_of_stock: "غير متوفر", preorder: "طلب مسبق" },
      searchPlaceholder: "بحث في المنتجات...",
      selectedCount: "{n} محدد",
      bulkEditSelected: "تعديل المحدد",
      includeSelected: "تفعيل المحدد",
      excludeSelected: "استبعاد المحدد",
      removeSelected: "حذف المحدد",
      bulkActionApplied: "تم تطبيق الإجراء على {n} منتج",
      bulkEditApplied: "تم تعديل {n} منتج",
      bulkEditFailed: "فشل التعديل الجماعي",
      pickFieldFirst: "اختر حقلاً واحداً على الأقل لتعديله",
      filterAll: "الكل",
      filterNoCategory: "— بدون فئة —",
      resultsCount: "{n} نتيجة",
      clearFilters: "مسح الفلاتر",
      bulkEditTitle: "تعديل جماعي على {n} منتج",
      bulkEditHint: "اترك أي حقل فارغاً إذا لم ترد تغييره. سيتم تطبيق التغييرات على المنتجات المحدّدة فقط.",
      leaveUnchanged: "بدون تغيير",
      applyBtn: "تطبيق",
      cancelBtn: "إلغاء",
      none: "بدون",
      noResults: "لا توجد نتائج",
      productsSelected: "{n} منتج محدد",
      cancel: "إلغاء",
      addBtn: "إضافة",
      totalInFeed: "إجمالي المنتجات في الكتالوج",
      activeProducts: "منتجات مفعّلة",
      excludedProducts: "منتجات مستبعدة",
      productName: "المنتج",
      price: "السعر",
    },
    affiliates: {
      title: "نظام العمولة",
      subtitle: "إدارة شركاء العمولة والتعويضات",
      addAffiliate: "إضافة شريك",
      editAffiliate: "تعديل الشريك",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      company: "الشركة",
      website: "الموقع الإلكتروني",
      trackingCode: "كود التتبع",
      commissionRate: "نسبة العمولة (%)",
      paymentMethod: "طريقة الدفع",
      bankDetails: "تفاصيل البنك",
      status: "الحالة",
      balance: "الرصيد",
      totalEarned: "إجمالي المكاسب",
      totalClicks: "إجمالي النقرات",
      totalOrders: "إجمالي الطلبات",
      name: "الاسم",
      actions: "الإجراءات",
      noAffiliates: "لا يوجد شركاء عمولة.",
      affiliateCreated: "تم إنشاء الشريك بنجاح.",
      affiliateUpdated: "تم تحديث الشريك بنجاح.",
      affiliateDeleted: "تم حذف الشريك.",
      saveFailed: "فشل حفظ بيانات الشريك.",
      pending: "قيد الانتظار",
      active: "نشط",
      inactive: "غير نشط",
      paymentMethods: {
        bank_transfer: "تحويل بنكي",
        paypal: "باي بال",
        wallet: "محفظة",
      },
      transactions: "المعاملات",
      addTransaction: "إضافة معاملة",
      txType: "النوع",
      txAmount: "المبلغ",
      txDescription: "الوصف",
      txStatus: "الحالة",
      txDate: "التاريخ",
      noTransactions: "لا توجد معاملات بعد.",
      txCreated: "تم إنشاء المعاملة.",
      txTypes: {
        commission: "عمولة",
        payment: "دفعة",
        adjustment: "تعديل",
      },
      txStatuses: {
        pending: "قيد الانتظار",
        approved: "معتمد",
        paid: "مدفوع",
        cancelled: "ملغي",
      },
    },
    emailCampaigns: {
      title: "إرسال بريد",
      subtitle: "إرسال حملات بريدية للعملاء",
      addCampaign: "حملة جديدة",
      editCampaign: "تعديل الحملة",
      name: "اسم الحملة (EN)",
      nameAr: "اسم الحملة (AR)",
      subject: "الموضوع (EN)",
      subjectAr: "الموضوع (AR)",
      content: "المحتوى بالإنجليزية (HTML)",
      contentAr: "المحتوى بالعربية (HTML)",
      recipientType: "المستلمون",
      recipientAll: "جميع العملاء",
      recipientGroup: "مجموعة عملاء",
      recipientNewsletter: "مشتركو النشرة البريدية",
      recipientCustom: "قائمة بريد مخصصة",
      recipientSpecific: "عملاء محددون",
      selectGroup: "اختر المجموعة",
      customEmailsLabel: "عناوين البريد الإلكتروني",
      customEmailsHint: "افصل العناوين بفاصلة أو سطر جديد. يتم تجاهل العناوين غير الصحيحة، والحد الأقصى 5000 عنوان.",
      validEmailsCount: "{count} عنوان بريد صالح",
      searchCustomers: "ابحث عن عميل بالاسم، البريد، أو الهاتف",
      addToList: "إضافة",
      removeEmailAria: "إزالة",
      noCustomersFound: "لا يوجد عملاء مطابقون",
      compose: "إنشاء",
      preview: "معاينة",
      previewArabic: "معاينة بالعربية",
      previewEnglish: "معاينة بالإنجليزية",
      previewEmpty: "لا يوجد محتوى للمعاينة. اكتب الرسالة في تبويب الإنشاء.",
      status: "الحالة",
      sentCount: "تم الإرسال",
      openCount: "الفتحات",
      scheduledAt: "الجدولة",
      sentAt: "تاريخ الإرسال",
      actions: "الإجراءات",
      noCampaigns: "لا توجد حملات بريدية.",
      campaignCreated: "تم إنشاء الحملة بنجاح.",
      campaignUpdated: "تم تحديث الحملة بنجاح.",
      campaignDeleted: "تم حذف الحملة.",
      saveFailed: "فشل حفظ الحملة.",
      sendNow: "إرسال الآن",
      sendConfirm: "هل أنت متأكد من إرسال هذه الحملة الآن؟",
      sending: "جاري الإرسال...",
      sendSuccess: "تم إرسال الحملة بنجاح!",
      sendFailed: "فشل إرسال الحملة.",
      statuses: {
        draft: "مسودة",
        scheduled: "مجدولة",
        sending: "جاري الإرسال",
        sent: "تم الإرسال",
        cancelled: "ملغاة",
      },
    },
    smsCampaigns: {
      title: "رسائل SMS",
      subtitle: "إرسال رسائل SMS و واتساب للعملاء",
      addCampaign: "رسالة جديدة",
      editCampaign: "تعديل الرسالة",
      name: "اسم الحملة",
      nameAr: "اسم الحملة (AR)",
      message: "الرسالة",
      messageAr: "الرسالة (AR)",
      recipientType: "المستلمون",
      recipientAll: "جميع العملاء",
      recipientGroup: "مجموعة عملاء",
      selectGroup: "اختر المجموعة",
      channel: "القناة",
      status: "الحالة",
      sentCount: "تم الإرسال",
      scheduledAt: "الجدولة",
      sentAt: "تاريخ الإرسال",
      actions: "الإجراءات",
      noCampaigns: "لا توجد حملات رسائل.",
      campaignCreated: "تم إنشاء الحملة بنجاح.",
      campaignUpdated: "تم تحديث الحملة بنجاح.",
      campaignDeleted: "تم حذف الحملة.",
      saveFailed: "فشل حفظ الحملة.",
      sendNow: "إرسال الآن",
      sendConfirm: "هل أنت متأكد من إرسال هذه الرسائل الآن؟",
      sending: "جاري الإرسال...",
      sendSuccess: "تم إرسال الرسائل بنجاح!",
      sendFailed: "فشل إرسال الرسائل.",
      channels: {
        sms: "SMS",
        whatsapp: "واتساب",
      },
      statuses: {
        draft: "مسودة",
        scheduled: "مجدولة",
        sending: "جاري الإرسال",
        sent: "تم الإرسال",
        cancelled: "ملغاة",
      },
      languageNote: "يستلم كل عميل الرسالة بلغته المفضلة. إذا تركت أحد الحقلين فارغًا، سيتم استخدام النسخة الأخرى.",
      scheduleSection: "الجدولة",
      scheduleSendLater: "إرسال لاحقًا",
      scheduleHelp: "إذا تم تحديد موعد، ستُرسل الرسالة تلقائيًا في الوقت المحدد دون تدخل يدوي.",
      filterSection: "تصفية المستلمين",
      filterLastOrderDays: "لم يطلبوا منذ (يوم على الأقل)",
      filterLastOrderHint: "استبعد العملاء الذين طلبوا مؤخرًا. مثال: 365 لاستهداف العملاء الذين لم يطلبوا منذ سنة.",
      filterTotalSpentMin: "إجمالي الإنفاق (الحد الأدنى)",
      filterTotalSpentMax: "إجمالي الإنفاق (الحد الأقصى)",
      filterClear: "مسح المرشحات",
      schedulingTitle: "مجدولة لـ",
      previewSection: "معاينة المستلمين",
      previewButton: "معاينة المستلمين",
      previewLoading: "جاري تحميل المستلمين...",
      previewEmpty: "لا يوجد عملاء يطابقون المرشحات الحالية.",
      previewMatched: "المطابقون",
      previewOptedOut: "المستبعدون (إلغاء اشتراك)",
      previewWillReceive: "سيستلمون الرسالة",
      previewColCustomer: "العميل",
      previewColPhone: "الهاتف",
      previewColLanguage: "اللغة",
      previewColTotalSpent: "إجمالي الإنفاق",
      previewColLastOrder: "آخر طلب",
      previewPageInfo: "صفحة {page} من {totalPages}",
      previewPrev: "السابق",
      previewNext: "التالي",
      previewHint: "هؤلاء هم العملاء الوحيدون الذين سيستلمون الرسالة. يتم استبعاد المسجلين في قائمة إلغاء الاشتراك تلقائيًا.",
    },
    blog: {
      title: "المدونة",
      settings: "إعدادات المدونة",
      categories: "أقسام المدونة",
      posts: "مقالات المدونة",
      comments: "تعليقات المدونة",
      settingsSubtitle: "إعداد العرض وتحسين محركات البحث للمدونة",
      categoriesSubtitle: "إدارة أقسام المقالات",
      postsSubtitle: "إنشاء وإدارة المقالات",
      commentsSubtitle: "مراجعة تعليقات القراء",
      postsPerPage: "المقالات في الصفحة",
      allowComments: "السماح بالتعليقات",
      moderateComments: "مراجعة التعليقات قبل النشر",
      showAuthor: "إظهار الكاتب",
      showDate: "إظهار التاريخ",
      showReadTime: "إظهار وقت القراءة",
      showShareButtons: "إظهار أزرار المشاركة",
      showRelatedPosts: "إظهار المقالات ذات الصلة",
      relatedPostsCount: "عدد المقالات ذات الصلة",
      seoTitle: "عنوان SEO للمدونة",
      seoTitleAr: "عنوان SEO للمدونة (AR)",
      seoDescription: "وصف SEO للمدونة",
      seoDescriptionAr: "وصف SEO للمدونة (AR)",
      settingsSaved: "تم حفظ إعدادات المدونة.",
      addCategory: "إضافة قسم",
      editCategory: "تعديل القسم",
      categoryName: "اسم القسم",
      categoryNameAr: "اسم القسم (AR)",
      categorySlug: "الرابط المختصر",
      categoryDescription: "الوصف",
      categoryDescriptionAr: "الوصف (AR)",
      categoryImage: "رابط الصورة",
      categorySortOrder: "ترتيب العرض",
      categoryStatus: "الحالة",
      noCategories: "لا توجد أقسام للمدونة بعد.",
      categoryCreated: "تم إنشاء القسم.",
      categoryUpdated: "تم تحديث القسم.",
      categoryDeleted: "تم حذف القسم.",
      addPost: "مقال جديد",
      editPost: "تعديل المقال",
      postTitle: "العنوان",
      postTitleAr: "العنوان (AR)",
      postSlug: "الرابط المختصر",
      autoGenerated: "يتم إنشاؤه تلقائياً إذا ترك فارغاً",
      postContent: "المحتوى (HTML)",
      postContentAr: "المحتوى بالعربية (HTML)",
      postExcerpt: "المقتطف",
      postExcerptAr: "المقتطف (AR)",
      postFeaturedImage: "رابط الصورة البارزة",
      postCategory: "القسم",
      postAuthor: "اسم الكاتب",
      postAuthorAr: "اسم الكاتب (AR)",
      postStatus: "الحالة",
      postPublishedAt: "تاريخ النشر",
      postTags: "الوسوم (مفصولة بفاصلة)",
      postTagsAr: "الوسوم بالعربية (مفصولة بفاصلة)",
      postMetaTitle: "عنوان الميتا",
      postMetaTitleAr: "عنوان الميتا (AR)",
      postMetaDescription: "وصف الميتا",
      postMetaDescriptionAr: "وصف الميتا (AR)",
      seoTab: "تحسين محركات البحث",
      seoTips: "نصائح SEO: اجعل عنوان الميتا أقل من 60 حرفاً. اجعل وصف الميتا أقل من 160 حرفاً. استخدم كلمات مفتاحية ذات صلة بكلتا اللغتين.",
      postAllowComments: "السماح بالتعليقات",
      postFeatured: "مقال مميز",
      postReadTime: "وقت القراءة",
      postViewCount: "المشاهدات",
      noPosts: "لا توجد مقالات بعد.",
      postCreated: "تم إنشاء المقال.",
      postUpdated: "تم تحديث المقال.",
      postDeleted: "تم حذف المقال.",
      saveFailed: "فشل الحفظ.",
      selectCategory: "اختر القسم",
      allCategories: "جميع الأقسام",
      allStatuses: "جميع الحالات",
      commentAuthor: "الكاتب",
      commentEmail: "البريد الإلكتروني",
      commentContent: "التعليق",
      commentPost: "المقال",
      commentStatus: "الحالة",
      commentDate: "التاريخ",
      noComments: "لا توجد تعليقات بعد.",
      commentUpdated: "تم تحديث حالة التعليق.",
      commentDeleted: "تم حذف التعليق.",
      approve: "موافقة",
      reject: "رفض",
      markSpam: "بريد مزعج",
      statuses: {
        draft: "مسودة",
        published: "منشور",
        scheduled: "مجدول",
        active: "نشط",
        inactive: "غير نشط",
        pending: "قيد المراجعة",
        approved: "معتمد",
        rejected: "مرفوض",
        spam: "بريد مزعج",
      },
      minutes: "دقيقة قراءة",
      views: "مشاهدة",
      comments_count: "تعليق",
      readMore: "اقرأ المزيد",
      searchPosts: "ابحث في المقالات...",
      noResults: "لم يتم العثور على مقالات.",
      shareArticle: "مشاركة المقال",
      relatedPosts: "مقالات ذات صلة",
      leaveComment: "اترك تعليقاً",
      yourName: "اسمك",
      yourEmail: "بريدك الإلكتروني",
      yourComment: "تعليقك",
      submitComment: "إرسال التعليق",
      commentSubmitted: "تم إرسال التعليق بنجاح! سيظهر بعد المراجعة.",
      commentFailed: "فشل إرسال التعليق.",
      backToBlog: "العودة للمدونة",
      featuredPosts: "مقالات مميزة",
      latestPosts: "أحدث المقالات",
      allPosts: "جميع المقالات",
      blogHome: "المدونة",
    },
    seo: {
      title: "تحسين محركات البحث",
      subtitle: "إدارة إعدادات تحسين محركات البحث",
      seoUrls: "روابط SEO",
      redirects: "إعادة التوجيه",
      sitemap: "خريطة الموقع",
      robotsTxt: "ملف Robots.txt",
      addUrl: "إضافة رابط SEO",
      editUrl: "تعديل رابط SEO",
      entityType: "نوع الكيان",
      entityId: "معرف الكيان",
      keyword: "الكلمة المفتاحية للرابط",
      metaTitle: "عنوان الميتا",
      metaTitleAr: "عنوان الميتا (عربي)",
      metaDescription: "وصف الميتا",
      metaDescriptionAr: "وصف الميتا (عربي)",
      metaKeywords: "كلمات الميتا المفتاحية",
      metaKeywordsAr: "كلمات الميتا المفتاحية (عربي)",
      canonicalUrl: "الرابط الأساسي (Canonical)",
      ogTitle: "عنوان OG",
      ogDescription: "وصف OG",
      ogImage: "رابط صورة OG",
      addRedirect: "إضافة إعادة توجيه",
      editRedirect: "تعديل إعادة توجيه",
      sourceUrl: "الرابط المصدر",
      targetUrl: "الرابط الهدف",
      statusCode: "رمز الحالة",
      hits: "الزيارات",
      generateSitemap: "إنشاء خريطة الموقع",
      sitemapGenerated: "تم إنشاء خريطة الموقع بنجاح",
      sitemapFailed: "فشل إنشاء خريطة الموقع",
      viewSitemap: "عرض خريطة الموقع",
      robotsContent: "محتوى Robots.txt",
      saveRobots: "حفظ Robots.txt",
      robotsSaved: "تم حفظ Robots.txt بنجاح",
      robotsFailed: "فشل حفظ Robots.txt",
      product: "منتج",
      category: "قسم",
      page: "صفحة",
      brand: "علامة تجارية",
      blogPost: "مقال مدونة",
      permanent301: "301 (دائم)",
      temporary302: "302 (مؤقت)",
      noUrls: "لا توجد روابط SEO",
      noRedirects: "لا توجد إعادة توجيه",
      urlSaved: "تم حفظ رابط SEO بنجاح",
      urlDeleted: "تم حذف رابط SEO",
      redirectSaved: "تم حفظ إعادة التوجيه بنجاح",
      redirectDeleted: "تم حذف إعادة التوجيه",
      saveFailed: "فشل الحفظ",
      deleteFailed: "فشل الحذف",
      sitemapTip: "ينشئ خريطة موقع XML تشمل جميع المنتجات والأقسام ومقالات المدونة والصفحات لفهرسة محركات البحث.",
      robotsTip: "يتحكم في الصفحات التي يمكن لمحركات البحث الزحف إليها. عدّل بحذر.",
      dashboard: "لوحة التحكم",
      dashboardDesc: "نظرة عامة على حالة SEO في متجرك",
      totalProducts: "إجمالي المنتجات",
      totalCategories: "إجمالي الأقسام",
      totalPages: "إجمالي الصفحات",
      totalBrands: "إجمالي الماركات",
      totalBlogPosts: "إجمالي مقالات المدونة",
      totalSeoUrls: "روابط SEO المُعدّة",
      totalRedirects: "إعادة التوجيه النشطة",
      missingMeta: "بيانات الميتا الناقصة",
      productsNoMeta: "منتجات بدون عنوان ميتا",
      categoriesNoMeta: "أقسام بدون عنوان ميتا",
      pagesNoMeta: "صفحات بدون عنوان ميتا",
      postsNoMeta: "مقالات بدون عنوان ميتا",
      productsNoDesc: "منتجات بدون وصف ميتا",
      seoHealth: "مؤشر صحة SEO",
      seoHealthGood: "جيد",
      seoHealthWarning: "يحتاج تحسين",
      seoHealthBad: "حرج",
      massUpdate: "التحديث الجماعي",
      massUpdateDesc: "توليد بيانات SEO بشكل جماعي من قوالب",
      selectEntityType: "اختر نوع الكيان",
      metaTitleTemplate: "قالب عنوان الميتا",
      metaTitleTemplateAr: "قالب عنوان الميتا (عربي)",
      metaDescTemplate: "قالب وصف الميتا",
      metaDescTemplateAr: "قالب وصف الميتا (عربي)",
      metaKeywordsTemplate: "قالب كلمات الميتا المفتاحية",
      metaKeywordsTemplateAr: "قالب كلمات الميتا المفتاحية (عربي)",
      templateHelp: "المتغيرات المتاحة: {name}، {nameAr}، {type}",
      generatePreview: "معاينة",
      applyAll: "تطبيق على الكل",
      applySelected: "تطبيق على المحدد",
      selectAll: "تحديد الكل",
      deselectAll: "إلغاء التحديد",
      generated: "المولّد",
      current: "الحالي",
      massUpdateSuccess: "تم التحديث الجماعي بنجاح",
      massUpdateCount: "كيان تم تحديثه",
      saveTemplate: "حفظ القالب",
      templateSaved: "تم حفظ القالب بنجاح",
      richSnippets: "المقتطفات المنسقة",
      richSnippetsDesc: "إدارة البيانات المنظمة (Schema.org) لنتائج البحث",
      enableRichSnippets: "تفعيل المقتطفات المنسقة",
      productSchema: "مخطط المنتج (السعر، التوفر، التقييم)",
      organizationSchema: "مخطط المؤسسة",
      breadcrumbSchema: "مخطط مسار التنقل",
      blogSchema: "مخطط المدونة/المقال",
      faqSchema: "مخطط الأسئلة الشائعة",
      orgName: "اسم المؤسسة",
      orgLogo: "رابط شعار المؤسسة",
      orgPhone: "هاتف المؤسسة",
      orgEmail: "بريد المؤسسة",
      socialLinks: "روابط التواصل الاجتماعي (رابط في كل سطر)",
      richSnippetsSaved: "تم حفظ إعدادات المقتطفات المنسقة",
      analytics: "التحليلات",
      analyticsDesc: "ربط خدمات التتبع والتحليلات",
      googleAnalyticsId: "معرف Google Analytics (GA4)",
      googleAnalyticsPlaceholder: "G-XXXXXXXXXX",
      googleTagManagerId: "معرف Google Tag Manager",
      googleTagManagerPlaceholder: "GTM-XXXXXXX",
      searchConsoleVerification: "التحقق من Google Search Console",
      searchConsolePlaceholder: "محتوى وسم التحقق",
      facebookPixelId: "معرف Facebook Pixel",
      snapchatPixelId: "معرف Snapchat Pixel",
      tiktokPixelId: "معرف TikTok Pixel",
      analyticsSaved: "تم حفظ إعدادات التحليلات",
      analyticsTip: "أدخل معرفات التتبع لربط خدمات التحليلات مع متجرك.",
    },
    appearance: {
      title: "المظهر",
      subtitle: "تخصيص مظهر وتصميم متجرك",
      colorsTab: "الألوان والخطوط",
      headerTab: "الرأس",
      footerTab: "التذييل",
      productTab: "عرض المنتجات",
      codeTab: "كود مخصص",
      primaryColor: "اللون الأساسي",
      secondaryColor: "اللون الثانوي",
      accentColor: "لون التمييز",
      backgroundColor: "لون الخلفية",
      textColor: "لون النص",
      fontFamily: "نوع الخط (EN)",
      fontFamilyAr: "نوع الخط (عربي)",
      fontSize: "حجم الخط الأساسي",
      borderRadius: "زوايا الحدود",
      headerBg: "خلفية الرأس",
      headerTextColor: "لون نص الرأس",
      headerLayout: "تخطيط الرأس",
      layoutDefault: "افتراضي",
      layoutCentered: "شعار بالمنتصف",
      layoutMinimal: "بسيط",
      stickyHeader: "رأس ثابت",
      topBarEnabled: "إظهار الشريط العلوي",
      topBarText: "نص الشريط العلوي",
      topBarTextAr: "نص الشريط العلوي (عربي)",
      topBarBg: "خلفية الشريط العلوي",
      topBarTextColor: "لون نص الشريط العلوي",
      footerBg: "خلفية التذييل",
      footerTextColor: "لون نص التذييل",
      footerLayout: "تخطيط التذييل",
      logoUrl: "رابط الشعار",
      faviconUrl: "رابط الأيقونة المفضلة",
      productCardStyle: "نمط بطاقة المنتج",
      styleDefault: "افتراضي",
      styleMinimal: "بسيط",
      styleBordered: "بحدود",
      productsPerRow: "منتجات لكل صف",
      showQuickView: "عرض المشاهدة السريعة",
      showWishlistBtn: "عرض زر المفضلة",
      showCompareBtn: "عرض زر المقارنة",
      backToTop: "زر العودة للأعلى",
      lazyLoadImages: "تحميل الصور البطيء",
      customCss: "CSS مخصص",
      customJs: "JavaScript مخصص",
      customHeaderCode: "كود الرأس المخصص (HTML)",
      customFooterCode: "كود التذييل المخصص (HTML)",
      settingsSaved: "تم حفظ إعدادات القالب بنجاح",
      settingsFailed: "فشل حفظ إعدادات القالب",
      resetDefaults: "إعادة التعيين الافتراضي",
      preview: "معاينة",
      cssTip: "أضف CSS مخصص لتجاوز الأنماط الافتراضية. التغييرات تطبق على كل الموقع.",
      jsTip: "أضف JavaScript مخصص. ينفذ في كل تحميل صفحة.",
      headerCodeTip: "يُحقن داخل وسم <head>. استخدمه للتحليلات والخطوط وغيرها.",
      footerCodeTip: "يُحقن قبل </body>. استخدمه لسكربتات التتبع.",
      importExportTab: "استيراد / تصدير",
      performanceTab: "الأداء",
      exportTheme: "تصدير القالب",
      exportThemeDesc: "تحميل جميع إعدادات القالب كملف JSON للنسخ الاحتياطي أو النقل إلى متجر آخر.",
      exportBtn: "تصدير الإعدادات",
      importTheme: "استيراد القالب",
      importThemeDesc: "رفع ملف إعدادات JSON تم تصديره مسبقاً لاستعادة أو تطبيق تهيئة القالب.",
      importBtn: "استيراد الإعدادات",
      importSuccess: "تم استيراد القالب بنجاح",
      importFailed: "فشل استيراد القالب. ملف غير صالح.",
      selectFile: "اختر ملف JSON",
      dragDrop: "أو اسحب وأفلت",
      fileSelected: "تم اختيار الملف",
      importWarning: "سيؤدي هذا إلى استبدال جميع إعدادات القالب الحالية. تأكد من تصدير إعداداتك الحالية أولاً.",
      perfLazyLoading: "التحميل الكسول للصور",
      perfLazyLoadingDesc: "تأجيل تحميل الصور غير المرئية حتى يتم التمرير إليها.",
      perfMinifyCss: "تصغير CSS",
      perfMinifyCssDesc: "إزالة المسافات والتعليقات من CSS لتقليل حجم الملف.",
      perfMinifyJs: "تصغير JavaScript",
      perfMinifyJsDesc: "ضغط مخرجات JavaScript لتسريع تحميل الصفحة.",
      perfCacheBusting: "تحديث ذاكرة التخزين",
      perfCacheBustingDesc: "إضافة هاش الإصدار إلى روابط الملفات لضمان تحميل أحدث نسخة دائماً.",
      perfPreconnect: "اتصال مسبق بـ CDN",
      perfPreconnectDesc: "إنشاء اتصالات مبكرة مع خوادم CDN لتسريع تحميل الموارد.",
      perfDeferJs: "تأجيل تحميل JavaScript",
      perfDeferJsDesc: "تأخير تنفيذ JavaScript غير الأساسي حتى تصبح الصفحة تفاعلية.",
      perfImageOptimize: "تحسين الصور",
      perfImageOptimizeDesc: "تقديم صيغ صور محسّنة (WebP) تلقائياً عند دعمها.",
      perfCriticalCss: "تضمين CSS الحرج",
      perfCriticalCssDesc: "تضمين CSS الجزء العلوي لتسريع العرض الأولي.",
      perfCacheTime: "مدة التخزين المؤقت",
      perfCacheTimeDesc: "المدة التي يجب أن يخزن فيها المتصفح الملفات الثابتة.",
      perfCacheOptions: {
        "1h": "ساعة واحدة",
        "1d": "يوم واحد",
        "1w": "أسبوع واحد",
        "1m": "شهر واحد",
        "1y": "سنة واحدة",
      },
    },
    activityLog: {
      title: "المتابعة",
      subtitle: "تتبع جميع العمليات المنفذة من قبل مشرفي المتجر",
      admin: "المستخدم",
      action: "العملية",
      actionType: "نوع العملية",
      entityType: "الصفحة",
      entityName: "العنصر",
      ipAddress: "عنوان IP",
      date: "التاريخ والوقت",
      details: "التفاصيل",
      allAdmins: "جميع المشرفين",
      allActions: "جميع العمليات",
      login: "تسجيل دخول",
      logout: "تسجيل خروج",
      create: "إنشاء",
      edit: "تعديل",
      delete: "حذف",
      view: "عرض",
      dateFrom: "من تاريخ",
      dateTo: "إلى تاريخ",
      search: "بحث...",
      clearFilters: "مسح الفلاتر",
      clearLogs: "إزالة السجلات",
      clearConfirm: "هل أنت متأكد من حذف جميع سجلات المتابعة؟ لا يمكن التراجع عن هذا الإجراء.",
      cleared: "تم مسح سجلات المتابعة بنجاح",
      noLogs: "لا توجد سجلات متابعة",
      filterByDate: "المتابعة خلال فترة محددة؟",
      products: "المنتجات",
      orders: "الطلبات",
      customers: "العملاء",
      categories: "الأقسام",
      settings: "الإعدادات",
      coupons: "القسائم",
      banners: "البانرات",
      pages: "الصفحات",
      returns: "المرتجعات",
      brands: "الماركات",
      extensions: "الإضافات",
      blog: "المدونة",
      seo: "تحسين محركات البحث",
      theme: "القالب",
    },
    abandonedCarts: {
      title: "السلات المتروكة",
      subtitle: "تتبع واسترداد سلات التسوق المتروكة",
      totalAbandoned: "إجمالي المتروكة",
      totalRecovered: "المستردة",
      recoveryRate: "معدل الاسترداد",
      potentialRevenue: "الإيرادات المحتملة",
      recoveredRevenue: "الإيرادات المستردة",
      cartId: "رقم السلة",
      customer: "العميل",
      email: "البريد",
      phone: "الهاتف",
      items: "العناصر",
      total: "الإجمالي",
      date: "التاريخ",
      status: "الحالة",
      actions: "الإجراءات",
      abandoned: "متروكة",
      recovered: "مستردة",
      reminderSent: "تم إرسال تذكير",
      sendReminder: "إرسال تذكير",
      sendEmail: "إرسال بريد",
      sendWhatsApp: "إرسال واتساب",
      markRecovered: "تحديد كمستردة",
      viewItems: "عرض العناصر",
      cartItems: "عناصر السلة",
      productName: "المنتج",
      quantity: "الكمية",
      price: "السعر",
      reminderCount: "التذكيرات المرسلة",
      lastReminder: "آخر تذكير",
      noCarts: "لا توجد سلات متروكة",
      reminderSentSuccess: "تم إرسال التذكير بنجاح",
      reminderFailed: "فشل إرسال التذكير",
      markedRecovered: "تم تحديد السلة كمستردة",
      filterAll: "جميع السلات",
      filterAbandoned: "المتروكة فقط",
      filterRecovered: "المستردة فقط",
      filterReminded: "تم التذكير",
      autoReminder: "التذكيرات التلقائية",
      autoReminderTip: "إرسال تذكيرات تلقائية للعملاء الذين تركوا سلاتهم بعد فترة محددة.",
      timeSinceAbandoned: "الوقت منذ الترك",
      hoursAgo: "ساعات مضت",
      daysAgo: "أيام مضت",
      minutesAgo: "دقائق مضت",
      guestCustomer: "زائر",
      settingsTab: "الإعدادات",
      templatesTab: "قوالب الرسائل",
      addEmailTemplate: "إضافة قالب بريد",
      addWhatsappTemplate: "إضافة قالب واتساب",
      editEmailTemplate: "تعديل قالب بريد",
      editWhatsappTemplate: "تعديل قالب واتساب",
      whatsappBody: "نص رسالة الواتساب (EN)",
      whatsappBodyAr: "نص رسالة الواتساب (عربي)",
      whatsappBodyHint: "رسائل الواتساب نص فقط بدون عنوان. تجنّب وسوم HTML.",
      statisticsTab: "الإحصائيات",
      couponsTab: "القسائم",
      cronTab: "المهام المجدولة",
      cartsTab: "السلات",
      enableExtension: "تفعيل الإضافة",
      dateFormatLabel: "تنسيق التاريخ",
      bccEmail: "نسخة مخفية (بريد المدير)",
      bccEmailPlaceholder: "admin@store.com",
      removeExpiredCoupons: "حذف القسائم منتهية الصلاحية",
      settingsSaved: "تم حفظ الإعدادات بنجاح",
      settingsFailed: "فشل حفظ الإعدادات",
      templateName: "اسم القالب (EN)",
      templateNameAr: "اسم القالب (عربي)",
      templateSubject: "عنوان البريد (EN)",
      templateSubjectAr: "عنوان البريد (عربي)",
      templateBody: "محتوى البريد بالإنجليزية (HTML)",
      templateBodyAr: "محتوى البريد (عربي)",
      delayHours: "الإرسال بعد (ساعات)",
      discountType: "نوع الخصم",
      discountNone: "بدون خصم",
      discountPercentage: "نسبة مئوية",
      discountFixed: "مبلغ ثابت",
      discountValue: "قيمة الخصم",
      discountExpiryDays: "صلاحية القسيمة (أيام)",
      customerGroups: "العملاء المستهدفون",
      allCustomers: "جميع العملاء",
      registeredOnly: "المسجلون فقط",
      guestsOnly: "الزوار فقط",
      templateChannel: "قناة الإرسال",
      addTemplate: "إضافة قالب",
      editTemplate: "تعديل قالب",
      templateSaved: "تم حفظ القالب",
      templateDeleted: "تم حذف القالب",
      noTemplates: "لا توجد قوالب رسائل بعد. أنشئ قالب بريد أو واتساب لأتمتة تذكيرات السلات المتروكة.",
      templateVarsHelp: "المتغيرات: {firstname}، {fullname}، {email}، {phone}، {total_amount}، {item_count}، {discount_code}، {store_name}، {currency}، {currency_symbol}، {cart_url}",
      templateVarsToolbarTitle: "المتغيرات المتاحة",
      templateVarsToolbarHint: "اضغط على المتغير لإدراجه في الرسالة، أو على أيقونة النسخ لنسخه",
      templateVarsInsertHint: "إدراج في الرسالة",
      templateVarsCopyHint: "نسخ المتغير",
      templatePreviewTitle: "معاينة مباشرة (بقيم تجريبية وعملة المتجر)",
      messageTemplatesTitle: "قوالب الرسائل (واتساب / بريد)",
      messageTemplatesDesc: "حرّر صياغة رسائل تذكير السلات المتروكة المرسلة للعملاء.",
      messageTemplatesHint: "تستخدم المبالغ تلقائياً عملة المتجر المضبوطة في إعدادات المتجر العامة.",
      cronEnabled: "تفعيل التذكيرات التلقائية",
      cronInterval: "فترة الفحص (دقائق)",
      cronMaxEmails: "الحد الأقصى للرسائل لكل دفعة",
      cronSchedule: "جدول CRON",
      runNow: "تشغيل الآن",
      cronProcessed: "تذكير تمت معالجته",
      cronTip: "عند التفعيل، يرسل النظام تذكيرات تلقائية بناءً على جدول قوالب البريد.",
      registeredVsGuests: "مسجلون مقابل زوار",
      registered: "مسجلون",
      guests: "زوار",
      topExitPages: "أكثر صفحات الخروج",
      pageUrl: "رابط الصفحة",
      exitCount: "العدد",
      totalReminded: "إجمالي المُذكَّرين",
      couponCode: "رمز القسيمة",
      couponDiscount: "الخصم",
      couponExpires: "تنتهي في",
      couponUsed: "مستخدمة",
      couponNotUsed: "غير مستخدمة",
      couponsTabDesc: "هذه القسائم يولّدها نظام التذكير تلقائياً لكل سلة متروكة، مرتبطة بقالب فيه نسبة خصم أو مبلغ خصم. ليست قسائم التسويق العامة (تجدها في «التسويق › القسائم»).",
      noCoupons: "لم يتم إنشاء قسائم بعد",
      noCouponsHint: "ستظهر هنا تلقائياً عند إرسال أول تذكير سلّة باستخدام قالب يحتوي على خصم. لإنشاء قسائم تسويقية يدوية للحملات، اذهب إلى «التسويق › القسائم».",
      totalCoupons: "إجمالي القسائم",
      usedCoupons: "القسائم المستخدمة",
      ipAddress: "عنوان IP",
      lastPage: "آخر صفحة تمت زيارتها",
      firstVisit: "أول زيارة",
      lastVisit: "آخر زيارة",
      deleteCart: "حذف",
    },
    layouts: {
      title: "التخطيطات",
      subtitle: "إدارة تخطيطات الصفحات ومواضع الوحدات",
      addLayout: "إضافة تخطيط",
      editLayout: "تعديل التخطيط",
      name: "اسم التخطيط",
      nameAr: "اسم التخطيط (عربي)",
      route: "نمط المسار",
      saved: "تم حفظ التخطيط بنجاح",
      deleted: "تم حذف التخطيط",
      modulesCount: "وحدات",
      manageModules: "الوحدات",
      modulesSaved: "تم تحديث الوحدات",
      noModulesAssigned: "لا توجد وحدات مُعيَّنة لهذا التخطيط",
      addModule: "إضافة وحدة",
      contentTop: "أعلى المحتوى",
      contentBottom: "أسفل المحتوى",
      columnLeft: "العمود الأيسر",
      columnRight: "العمود الأيمن",
    },
    modules: {
      title: "الوحدات",
      subtitle: "إنشاء وإدارة وحدات العرض للتخطيطات",
      addModule: "إضافة وحدة",
      editModule: "تعديل الوحدة",
      name: "اسم الوحدة",
      nameAr: "اسم الوحدة (عربي)",
      type: "نوع الوحدة",
      saved: "تم حفظ الوحدة بنجاح",
      deleted: "تم حذف الوحدة",
      moduleTitle: "العنوان",
      moduleTitleAr: "العنوان (عربي)",
      typeHtml: "كتلة HTML",
      typeBanner: "بانر",
      typeSlider: "سلايدر",
      typeProductGrid: "شبكة منتجات",
      typeFeatured: "منتجات مميزة",
      typeLatest: "أحدث المنتجات",
      htmlContent: "محتوى HTML",
      htmlContentAr: "محتوى HTML (عربي)",
      imageUrl: "رابط الصورة",
      linkUrl: "رابط الوجهة",
      autoplay: "تشغيل تلقائي",
      interval: "الفاصل الزمني (مللي ثانية)",
      limit: "حد المنتجات",
      columns: "الأعمدة",
    },
    productExtras: {
      title: "إضافات المنتجات",
      subtitle: "إدارة شارات المنتجات والتبويبات المخصصة",
      labelsTab: "الشارات",
      tabsTab: "التبويبات المخصصة",
      labelsDesc: "إنشاء شارات وعلامات لتمييز المنتجات",
      tabsDesc: "إضافة تبويبات معلومات مخصصة لصفحات المنتجات",
      addLabel: "إضافة شارة",
      editLabel: "تعديل الشارة",
      labelSaved: "تم حفظ الشارة",
      labelDeleted: "تم حذف الشارة",
      noLabels: "لم يتم إنشاء شارات بعد",
      labelName: "اسم الشارة",
      labelNameAr: "اسم الشارة (عربي)",
      labelText: "نص العرض",
      labelTextAr: "نص العرض (عربي)",
      bgColor: "لون الخلفية",
      textColorLabel: "لون النص",
      position: "الموضع",
      posTopRight: "أعلى اليمين",
      posTopLeft: "أعلى اليسار",
      posBottomRight: "أسفل اليمين",
      posBottomLeft: "أسفل اليسار",
      products: "المنتجات",
      addTab: "إضافة تبويب",
      editTab: "تعديل التبويب",
      tabSaved: "تم حفظ التبويب",
      tabDeleted: "تم حذف التبويب",
      noTabs: "لم يتم إنشاء تبويبات مخصصة بعد",
      tabName: "اسم التبويب",
      tabNameAr: "اسم التبويب (عربي)",
      tabContent: "المحتوى",
      tabContentAr: "المحتوى (عربي)",
      applyTo: "تطبيق على",
      applyAll: "جميع المنتجات",
      applyProducts: "منتجات محددة",
      applyCategories: "أقسام محددة",
      sortOrder: "ترتيب الفرز",
    },
    seoEditor: {
      title: "محرر SEO",
      subtitle: "تعديل بيانات SEO لجميع الصفحات في مكان واحد",
      entityName: "العنصر",
      entityType: "النوع",
      metaTitle: "عنوان الميتا",
      metaDescription: "وصف الميتا",
      metaKeywords: "كلمات الميتا المفتاحية",
      urlKeyword: "كلمة URL المفتاحية",
      saveChanges: "حفظ التغييرات",
      saved: "تم حفظ بيانات SEO",
      noChanges: "لا توجد تغييرات للحفظ",
      filterType: "تصفية حسب النوع",
      allTypes: "جميع الأنواع",
      product: "منتج",
      category: "قسم",
      brand: "علامة تجارية",
      page: "صفحة",
      blogPost: "مقال",
      modified: "معدَّل",
      searchPlaceholder: "ابحث بالاسم أو كلمة URL أو عنوان الميتا (عربي أو إنجليزي)...",
      showingResults: "عرض {from}-{to} من {total}",
      previous: "السابق",
      next: "التالي",
      pageOf: "صفحة {current} من {total}",
      english: "إنجليزي",
      arabic: "عربي",
      enPlaceholder: "English…",
      arPlaceholder: "بالعربية…",
      statusFilter: "الحالة",
      statusAll: "الكل",
      statusMissing: "بيانات ميتا مفقودة",
      statusPartial: "لغة واحدة فقط",
      statusComplete: "مكتملة (عربي + إنجليزي)",
      saveFailed: "فشل الحفظ",
    },
    advancedStyles: {
      title: "الأنماط المتقدمة",
      subtitle: "تخصيص أنماط العناصر المحددة عبر متجرك",
      buttons: "أنماط الأزرار",
      buttonsDesc: "تخصيص مظهر الأزرار",
      primaryBtnBg: "خلفية الزر الرئيسي",
      primaryBtnText: "نص الزر الرئيسي",
      primaryBtnRadius: "انحناء الزر الرئيسي",
      secondaryBtnBg: "خلفية الزر الثانوي",
      secondaryBtnText: "نص الزر الثانوي",
      menus: "أنماط القوائم",
      menusDesc: "تخصيص قوائم التنقل",
      menuBg: "خلفية القائمة",
      menuText: "لون نص القائمة",
      menuHover: "لون التحويم",
      menuFontSize: "حجم خط القائمة",
      typography: "الطباعة",
      typographyDesc: "تخصيص أنماط النصوص والروابط",
      headingFont: "خط العناوين",
      bodyFont: "خط النص",
      linkColor: "لون الروابط",
      linkHoverColor: "لون تحويم الروابط",
      badges: "أنماط الشارات",
      badgesDesc: "تخصيص مظهر الشارات والعلامات",
      saleBadgeBg: "خلفية شارة التخفيض",
      saleBadgeText: "نص شارة التخفيض",
      newBadgeBg: "خلفية شارة الجديد",
      newBadgeText: "نص شارة الجديد",
      saved: "تم حفظ الأنماط بنجاح",
    },
    warehouses: {
      title: "المستودعات",
      subtitle: "إدارة مواقع المخزون المتعددة",
      addWarehouse: "إضافة مستودع",
      editWarehouse: "تعديل مستودع",
      name: "اسم المستودع",
      nameAr: "الاسم (عربي)",
      code: "الرمز",
      address: "العنوان",
      city: "المدينة",
      country: "الدولة",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      priority: "الأولوية",
      status: "الحالة",
      active: "نشط",
      inactive: "غير نشط",
      products: "المنتجات",
      totalStock: "إجمالي المخزون",
      stockManagement: "إدارة المخزون",
      quantity: "الكمية",
      updateStock: "تحديث المخزون",
      transfer: "نقل المخزون",
      fromWarehouse: "من مستودع",
      toWarehouse: "إلى مستودع",
      transferHistory: "سجل التحويلات",
      noWarehouses: "لا توجد مستودعات بعد",
      saved: "تم حفظ المستودع بنجاح",
      deleted: "تم حذف المستودع",
      transferSuccess: "تم نقل المخزون بنجاح",
      selectProduct: "اختر منتجًا",
      searchByNameOrSku: "ابحث بالاسم أو رمز المنتج (SKU)…",
      selectFromWarehouseFirst: "اختر المستودع المصدر أولاً",
      noProductsInWarehouse: "لا توجد منتجات في هذا المستودع",
      noMatchingProducts: "لا توجد منتجات مطابقة",
      available: "متاح",
      seedFromProducts: "تهيئة المخزون من المنتجات",
      seedConfirm: "سيتم نسخ مخزون كل المنتجات الحالي إلى المستودع المحدد، وإزالة الصفوف اليتيمة. متابعة؟",
      seedNoTarget: "اختر مستودعاً مستهدفاً أولاً",
      seedSuccess: "تمت التهيئة بنجاح",
    },
    b2b: {
      title: "تجارة B2B",
      companies: "الشركات",
      companiesSubtitle: "إدارة حسابات الشركات B2B",
      addCompany: "إضافة شركة",
      editCompany: "تعديل شركة",
      companyName: "اسم الشركة",
      nameAr: "الاسم (عربي)",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      taxId: "الرقم الضريبي",
      address: "العنوان",
      city: "المدينة",
      country: "الدولة",
      industry: "القطاع",
      creditLimit: "الحد الائتماني",
      paymentTerms: "شروط الدفع",
      status: "الحالة",
      users: "المستخدمون",
      addUser: "إضافة مستخدم",
      role: "الدور",
      buyer: "مشتري",
      manager: "مدير",
      admin: "مسؤول",
      canApprove: "يمكنه الموافقة على الطلبات",
      spendingLimit: "حد الإنفاق",
      search: "ابحث باسم الشركة أو البريد الإلكتروني...",
      noSearchResults: "لا توجد شركات مطابقة لبحثك",
      statTotal: "إجمالي الشركات",
      statActive: "شركات نشطة",
      statCredit: "إجمالي الحد الائتماني",
      statUsers: "مستخدمو B2B",
      active: "نشطة",
      inactive: "غير نشطة",
      suspended: "موقوفة",
      termImmediate: "دفع فوري",
      termNet15: "آجل 15 يوماً",
      termNet30: "آجل 30 يوماً",
      termNet60: "آجل 60 يوماً",
      termNet90: "آجل 90 يوماً",
      manageUsers: "إدارة المستخدمين",
      noUsers: "لا يوجد مستخدمون مرتبطون بهذه الشركة بعد",
      confirmDelete: "هل تريد حذف هذه الشركة نهائياً؟",
      contactInfo: "بيانات التواصل",
      billingInfo: "الفوترة وشروط الدفع",
      selectCustomer: "اختر عميلاً لإضافته",
      permissions: "الصلاحيات",
      approveHint: "يستطيع هذا المستخدم اعتماد طلبات الشركة",
      viewQuotes: "عروض الأسعار",
      noCompanies: "لا توجد شركات بعد",
      saved: "تم حفظ الشركة بنجاح",
      deleted: "تم حذف الشركة",
      quotes: "عروض الأسعار",
      quotesSubtitle: "إدارة عروض الأسعار B2B",
      addQuote: "إضافة عرض سعر",
      editQuote: "تعديل عرض سعر",
      customerName: "اسم العميل",
      customerEmail: "بريد العميل",
      subtotal: "المجموع الفرعي",
      discount: "الخصم",
      total: "الإجمالي",
      notes: "ملاحظات",
      adminNotes: "ملاحظات المسؤول",
      validUntil: "صالح حتى",
      pending: "قيد الانتظار",
      approved: "مُوافق",
      rejected: "مرفوض",
      expired: "منتهي",
      noQuotes: "لا توجد عروض أسعار بعد",
      quoteSaved: "تم حفظ عرض السعر بنجاح",
      quoteDeleted: "تم حذف عرض السعر",
    },
    contentStaging: {
      title: "جدولة المحتوى",
      subtitle: "جدولة نشر وإلغاء نشر المحتوى",
      publishAt: "النشر في",
      unpublishAt: "إلغاء النشر في",
      entityType: "نوع المحتوى",
      product: "منتج",
      banner: "بانر",
      category: "قسم",
      scheduled: "مجدول",
      process: "معالجة الآن",
      processSuccess: "تمت المعالجة: {published} تم نشره، {unpublished} تم إلغاء نشره",
      noScheduled: "لا يوجد محتوى مجدول",
      schedule: "جدولة",
      clearSchedule: "إلغاء الجدولة",
      scheduleSaved: "تم حفظ الجدولة بنجاح",
    },
    pricingRules: {
      title: "قواعد التسعير",
      subtitle: "قواعد التسعير المتقدمة والتسعير المتدرج",
      addRule: "إضافة قاعدة",
      editRule: "تعديل قاعدة",
      name: "اسم القاعدة",
      nameAr: "الاسم (عربي)",
      type: "النوع",
      cartRule: "قاعدة سلة",
      catalogRule: "قاعدة كتالوج",
      discountType: "نوع الخصم",
      percentage: "نسبة مئوية",
      fixedAmount: "مبلغ ثابت",
      buyXgetY: "اشتر X واحصل على Y",
      discountValue: "قيمة الخصم",
      priority: "الأولوية",
      stopProcessing: "إيقاف المعالجة",
      customerGroup: "مجموعة العملاء",
      startDate: "تاريخ البداية",
      endDate: "تاريخ النهاية",
      usageLimit: "حد الاستخدام",
      usedCount: "عدد الاستخدامات",
      conditions: "الشروط",
      minCartTotal: "الحد الأدنى لمجموع السلة",
      minQuantity: "الحد الأدنى للكمية",
      specificProducts: "منتجات محددة",
      specificCategories: "أقسام محددة",
      noRules: "لا توجد قواعد تسعير بعد",
      saved: "تم حفظ قاعدة التسعير بنجاح",
      deleted: "تم حذف قاعدة التسعير",
      tieredPricing: "التسعير المتدرج",
      minQty: "الحد الأدنى",
      maxQty: "الحد الأقصى",
      price: "السعر",
      addTier: "إضافة مستوى",
    },
    aiSearch: {
      title: "البحث الذكي والتوصيات",
      subtitle: "بحث ذكي مع مترادفات وتوصيات شخصية",
      synonyms: "مترادفات البحث",
      addSynonym: "إضافة مترادف",
      keyword: "الكلمة المفتاحية",
      synonymsList: "المترادفات (مفصولة بفاصلة)",
      noSynonyms: "لا توجد مترادفات بحث بعد",
      synonymSaved: "تم حفظ المترادف",
      synonymDeleted: "تم حذف المترادف",
      didYouMean: "هل تقصد",
      trending: "المنتجات الرائجة",
      recommended: "موصى لك",
      similarProducts: "منتجات مشابهة",
    },
    inventory: {
      title: "إدارة المخزون",
      subtitle: "إدارة شاملة للمخزون ومراقبة المستودعات",
      dashboard: "لوحة التحكم",
      products: "مستويات المخزون",
      adjustments: "تعديلات المخزون",
      history: "سجل الحركات",
      counts: "جرد المخزون",
      alerts: "تنبيهات المخزون",
      valuation: "تقييم المخزون",
      suppliers: "الموردون",
      totalProducts: "المنتجات المتتبعة",
      totalUnits: "إجمالي الوحدات",
      costValue: "قيمة التكلفة",
      retailValue: "قيمة البيع",
      outOfStock: "نفد من المخزون",
      lowStock: "مخزون منخفض",
      overstocked: "مخزون زائد",
      inStock: "متوفر",
      warehouses: "المستودعات",
      recentMovements: "حركات المخزون الأخيرة",
      topMovers: "الأكثر حركة (30 يوم)",
      stockByWarehouse: "المخزون حسب المستودع",
      search: "ابحث بالاسم أو SKU أو الباركود...",
      allProducts: "جميع المنتجات",
      filterLowStock: "مخزون منخفض",
      filterOutOfStock: "نفد المخزون",
      filterOverstocked: "مخزون زائد",
      filterBackorder: "طلب مسبق",
      sku: "SKU",
      barcode: "الباركود",
      currentStock: "المخزون الحالي",
      costPrice: "سعر التكلفة",
      reorderPoint: "نقطة إعادة الطلب",
      reorderQty: "كمية إعادة الطلب",
      minStock: "الحد الأدنى",
      maxStock: "الحد الأقصى",
      trackInventory: "تتبع المخزون",
      allowBackorder: "السماح بالطلب المسبق",
      locationLabel: "موقع التخزين",
      adjustStock: "تعديل المخزون",
      quantity: "الكمية",
      reason: "السبب",
      reasonReceived: "استلام / شراء",
      reasonSold: "مبيعات",
      reasonReturned: "مرتجع عميل",
      reasonDamaged: "تالف / معيب",
      reasonLost: "مفقود / سرقة",
      reasonCorrection: "تصحيح يدوي",
      reasonTransfer: "تحويل بين مستودعات",
      reasonPromotion: "استخدام ترويجي",
      reference: "رقم المرجع",
      notes: "ملاحظات",
      increase: "زيادة (+)",
      decrease: "نقصان (-)",
      adjustmentSuccess: "تم تعديل المخزون بنجاح",
      bulkAdjust: "تعديل جماعي",
      movementType: "النوع",
      before: "قبل",
      after: "بعد",
      change: "التغيير",
      date: "التاريخ",
      admin: "المسؤول",
      warehouse: "المستودع",
      noHistory: "لا يوجد سجل حركات مخزون",
      newCount: "جرد جديد",
      countName: "اسم الجرد",
      startCount: "بدء الجرد",
      completeCount: "إكمال الجرد",
      applyCount: "تطبيق التعديلات",
      systemQty: "كمية النظام",
      countedQty: "الكمية المُعدّة",
      variance: "الفرق",
      noCounts: "لا يوجد جرد مخزون بعد",
      countCreated: "تم إنشاء الجرد",
      countApplied: "تم تطبيق تعديلات الجرد",
      draft: "مسودة",
      inProgress: "قيد التنفيذ",
      completed: "مكتمل",
      applied: "مُطبّق",
      lowStockAlert: "تنبيه مخزون منخفض",
      outOfStockAlert: "تنبيه نفاد المخزون",
      overstockedAlert: "تنبيه مخزون زائد",
      noAlerts: "لا توجد تنبيهات مخزون",
      needsReorder: "يحتاج إعادة طلب",
      backorderEnabled: "الطلب المسبق مفعّل",
      supplierName: "اسم المورد",
      supplierEmail: "البريد الإلكتروني",
      supplierPhone: "رقم الهاتف",
      supplierSku: "SKU المورد",
      leadTime: "وقت التوريد (أيام)",
      minOrder: "الحد الأدنى للطلب",
      primarySupplier: "المورد الرئيسي",
      addSupplier: "إضافة مورد",
      noSuppliers: "لا يوجد موردون مسجلون",
      totalCostValue: "إجمالي قيمة التكلفة",
      totalRetailValue: "إجمالي قيمة البيع",
      potentialProfit: "الربح المتوقع",
      marginPercent: "نسبة الهامش %",
      exportReport: "تصدير التقرير",
      product: "المنتج",
      category: "القسم",
      stockStatus: "حالة المخزون",
      actions: "الإجراءات",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      close: "إغلاق",
      confirm: "تأكيد",
      saved: "تم الحفظ بنجاح",
      deleted: "تم الحذف بنجاح",
      saveFailed: "فشل الحفظ",
      refresh: "تحديث",
      // ===== Multi-type inventory (Phase 8) =====
      stockTypes: "أنواع المخزون",
      procurement: "طلبات التوريد",
      selectProductForBreakdown: "اختر منتجاً من القائمة لعرض تفصيل أنواع المخزون",
      totalSellable: "المتاح للبيع (الإجمالي)",
      ownedCostValue: "قيمة المخزون المملوك",
      depletionStrategy: "استراتيجية الاستهلاك",
      depletionStrategyDesc: "الترتيب الذي يُخصم به المخزون عند البيع — تأثير مباشر على هامش الربح",
      strategies: {
        consignment_first: "تحت التصريف أولاً (هامش أعلى)",
        physical_first: "الفعلي أولاً",
        physical_only: "الفعلي فقط",
        on_demand_only: "بالطلب فقط (دروب-شيب)",
      },
      physicalStock: "المخزون الفعلي",
      physicalStockDesc: "البضاعة المملوكة فعلياً في مستودعك — يُخصم عند البيع ويُحتسب بسعر التكلفة",
      editPhysicalHint: "للتعديل استخدم تبويب «تعديلات المخزون»",
      consignmentStock: "بضاعة تحت التصريف",
      consignmentStockDesc: "بضاعة موجودة في مستودعك لكن مملوكة لمورد — تكلفتها عليك صفر، تُسوّى مع المالك بعد البيع",
      consignmentOwner: "المالك (المورد)",
      onDemandStock: "مخزون بالطلب (دروب-شيب)",
      onDemandStockDesc: "كميات افتراضية لا توجد فعلياً — عند بيع قطعة يُنشأ طلب توريد للمورد ولا يُخصم من المخزون",
      virtualCapacity: "السعة الافتراضية",
      onDemandHint: "ملاحظة: بيع القطعة من هنا لا يُنقص الكمية، بل يُنشئ طلب توريد جديد في تبويب «طلبات التوريد».",
      noSupplier: "بدون مورد",
      // Procurement
      allStatuses: "كل الحالات",
      procurementStatus: {
        pending: "قيد الانتظار",
        ordered: "تم الطلب",
        received: "وصل المستودع",
        fulfilled: "تم تسليم العميل",
        cancelled: "ملغي",
      },
      noProcurementRequests: "لا توجد طلبات توريد",
      unitCost: "تكلفة الوحدة",
      unitCostPrompt: "أدخل تكلفة الوحدة من المورد:",
      expectedAt: "التاريخ المتوقع",
      markOrdered: "تم الطلب من المورد",
      markReceived: "وصل المستودع",
      markFulfilled: "سُلّم العميل",
    },
  },
};

export default ar;
